import { AppleEmoji } from '../components/Emoji';
import { IconFolder, IconChevronLeft, IconChevronRight, IconLayers, IconEye, IconEdit, IconMessage, IconPlus, IconCalendar, IconCalendarDays, IconPalette, IconBuilding, IconCheck, IconTrash, IconImage, IconVideo, IconSparkles, IconCopy, IconSave, IconUpload, IconSearch, IconRefresh, IconCamera, IconMic, IconUsers } from '../components/Icons';
import { useLocation, useNavigate } from 'react-router-dom';
import React, { useEffect, useState, useRef, useMemo } from 'react';
import Sidebar from '../components/Sidebar';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import { toast } from 'react-hot-toast';

const getFilesArray = (files: any): string[] => {
  if (!files) return [];
  if (Array.isArray(files)) return files.map(f => typeof f === 'string' ? f : (f.url || f.fileUrl || '')).filter(Boolean);
  if (typeof files === 'string') {
    try {
      const parsed = JSON.parse(files);
      if (Array.isArray(parsed)) return parsed.map(f => typeof f === 'string' ? f : (f.url || f.fileUrl || '')).filter(Boolean);
    } catch {
      return [files];
    }
  }
  return [];
};


const isStatusMatch = (pieceStatus: string, tabStatus: string) => {
  if (tabStatus === 'ALL') return true;
  if (tabStatus === 'APROBADO') return pieceStatus === 'APROBADO' || pieceStatus === 'SUBIDO';
  if (tabStatus === 'EN_PRODUCCION') return pieceStatus === 'EN_PRODUCCION' || pieceStatus === 'PENDIENTE';
  if (tabStatus === 'REVISION_INTERNA') return pieceStatus === 'REVISION_INTERNA';
  if (tabStatus === 'REVISION_CLIENTE') return pieceStatus === 'REVISION_CLIENTE';
  return pieceStatus === tabStatus;
};


const STATUS_FLOW = ['PENDIENTE', 'EN_PRODUCCION', 'REVISION_INTERNA', 'REVISION_CLIENTE', 'APROBADO'];
const STATUS_LABELS: Record<string, string> = {
  ALL: 'Todas',
  PENDIENTE: 'Pendiente',
  EN_PRODUCCION: 'En producción',
  REVISION_INTERNA: 'Revisión interna',
  REVISION_CLIENTE: 'Revisión cliente',
  APROBADO: 'Aprobado',
  SUBIDO: 'Subido'
};
const STATUS_COLORS: Record<string, string> = {
  PENDIENTE: '#64748b',
  EN_PRODUCCION: '#2688c9',
  REVISION_INTERNA: '#2bb0e6',
  REVISION_CLIENTE: '#f59e0b',
  APROBADO: '#10b981',
  SUBIDO: '#059669'
};

const FORMAT_ICONS: Record<string, string> = {
  ESTATICA: '',
  ANIMACION: '',
  VIDEO: '',
  CARRUSEL: '📑'
};

const MONTH_NAMES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

const isImage = (url: any) => typeof url === 'string' && /\.(jpg|jpeg|png|gif|webp|svg)(\?.*)?$/i.test(url);
const isVideo = (url: any) => typeof url === 'string' && /\.(mp4|webm|mov|ogg)(\?.*)?$/i.test(url);

const parseImageUrls = (urls: any): string[] => {
  if (!urls) return [];
  if (Array.isArray(urls)) return urls.filter(u => typeof u === 'string');
  if (typeof urls === 'string') {
    try {
      const parsed = JSON.parse(urls);
      if (Array.isArray(parsed)) return parsed.filter(u => typeof u === 'string');
    } catch {
      return [urls];
    }
  }
  return [];
};

// Generador dinámico de semanas calendario estilo Google Calendar (Lunes a Domingo)
const getWeeksForMonth = (monthNum: number, year: number = new Date().getFullYear()) => {
  if (!monthNum || monthNum < 1 || monthNum > 12) return [];
  const weeks: { id: string; label: string; start: Date; end: Date }[] = [];
  const daysInMonth = new Date(year, monthNum, 0).getDate();
  const monthShort = MONTH_NAMES[monthNum - 1].slice(0, 3);

  let weekStartDay = 1;
  let weekIdx = 1;

  while (weekStartDay <= daysInMonth) {
    const startDate = new Date(year, monthNum - 1, weekStartDay, 0, 0, 0);
    const dayOfWeek = startDate.getDay(); // 0: Domingo, 1: Lunes...
    const daysToSunday = dayOfWeek === 0 ? 0 : 7 - dayOfWeek;
    const weekEndDay = Math.min(daysInMonth, weekStartDay + daysToSunday);
    const endDate = new Date(year, monthNum - 1, weekEndDay, 23, 59, 59, 999);

    const label = `Semana ${weekIdx} (${weekStartDay} al ${weekEndDay} ${monthShort})`;

    weeks.push({
      id: String(weekIdx),
      label,
      start: startDate,
      end: endDate
    });

    weekStartDay = weekEndDay + 1;
    weekIdx++;
  }

  return weeks;
};

export const Content: React.FC = () => {
  const { user } = useAuth();
  const isAlejandra = (user?.email || '').toLowerCase() === 'contabilidadzoikagency@gmail.com';

  const location = useLocation();

  

  const [pieces, setPieces] = useState<any[]>([]);
  const [brands, setBrands] = useState<any[]>([]);
  const [users, setUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  // Estados para Selección y Eliminación Masiva de Fichas
  const [selectedPieceIds, setSelectedPieceIds] = useState<string[]>([]);
  const [isSelectionMode, setIsSelectionMode] = useState(false);
  const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
  const [isBulkDeleting, setIsBulkDeleting] = useState(false);

  // Estados para Carga Masiva de Fichas
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [bulkBrandId, setBulkBrandId] = useState('');
  const [bulkDesignerId, setBulkDesignerId] = useState('');
  const [bulkDate, setBulkDate] = useState(new Date().toISOString().slice(0, 10));
  const [bulkMaterialsBoardId, setBulkMaterialsBoardId] = useState('');
  const [brandCuadros, setBrandCuadros] = useState<any[]>([]);
  const [bulkItems, setBulkItems] = useState<{ title: string; type: string; files: File[]; previewUrls: string[] }[]>([]);
  const [isProcessingBulk, setIsProcessingBulk] = useState(false);
  const [bulkProgressText, setBulkProgressText] = useState('');
  const bulkFolderInputRef = useRef<HTMLInputElement>(null);
  // Cargar cuadros/procesos de la marca seleccionada en la carga masiva
  useEffect(() => {
    if (bulkBrandId) {
      api.get(`/processes?brandId=${bulkBrandId}`)
        .then(r => setBrandCuadros(Array.isArray(r.data) ? r.data : []))
        .catch(() => setBrandCuadros([]));
    } else {
      setBrandCuadros([]);
    }
    setBulkMaterialsBoardId('');
  }, [bulkBrandId]);

  const bulkFilesInputRef = useRef<HTMLInputElement>(null);

  // Filtros
  const currentMonthIdx = new Date().getMonth() + 1;
  const [filterStatus, setFilterStatus] = useState<string>('ALL');
  const [filterMonth, setFilterMonth] = useState<string>('all');
  const [filterWeek, setFilterWeek] = useState<string>('all');
  const [filterBrand, setFilterBrand] = useState<string>('');
  const [filterUser, setFilterUser] = useState<string>('');
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [openGlassDropdown, setOpenGlassDropdown] = useState<'month' | 'week' | 'user' | 'brand' | null>(null);
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);
  const searchInputRef = useRef<HTMLInputElement>(null);
  const dropdownContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownContainerRef.current && !dropdownContainerRef.current.contains(e.target as Node)) {
        setOpenGlassDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Modales
  const [selected, setSelected] = useState<any>(null);
  const [lightboxUrl, setLightboxUrl] = useState<string | null>(null);
  const [comments, setComments] = useState<any[]>([]);
  const [commentText, setCommentText] = useState('');

  // Estados para Carruseles de 10 Diapositivas y Cuadros de Material
  const [activeSlideIdx, setActiveSlideIdx] = useState<number>(0);
  const [slideCommentFilter, setSlideCommentFilter] = useState<'CURRENT' | 'ALL'>('CURRENT');
  const [commentTargetSlide, setCommentTargetSlide] = useState<string>('CURRENT');
  const [driveFiles, setDriveFiles] = useState<any[]>([]);
  const [currentDriveFileIdx, setCurrentDriveFileIdx] = useState<number>(0);
  const [loadingDriveFiles, setLoadingDriveFiles] = useState<boolean>(false);
  const [brandDriveFolders, setBrandDriveFolders] = useState<any[]>([]);

  const [sendingComment, setSendingComment] = useState(false);
  const [uploadingCommentImg, setUploadingCommentImg] = useState(false);
  const commentImgRef = useRef<HTMLInputElement>(null);

  // IA y Edición de Copy
  const [generatingCopy, setGeneratingCopy] = useState(false);
  const [isEditingCopy, setIsEditingCopy] = useState(false);
  const [editedCopy, setEditedCopy] = useState('');

  // Audio (Notas de Voz)
  const [isRecording, setIsRecording] = useState(false);
  const [recSeconds, setRecSeconds] = useState(0);
  const [sendingAudio, setSendingAudio] = useState(false);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const audioChunksRef = useRef<Blob[]>([]);
  const timerRef = useRef<any>(null);

  // Re-subida de archivo
  const [uploadingFile, setUploadingFile] = useState(false);
  const replaceFileRef = useRef<HTMLInputElement>(null);

  // Modal Nueva Pieza
  const [showNewModal, setShowNewModal] = useState(false);
  useEffect(() => {
    api.get('/drive/folders/tree').then(res => {
      const fols = Array.isArray(res.data) ? res.data : [];
      setBrandFoldersList(fols);
    }).catch(() => {});
  }, [showNewModal]);
  const [newForm, setNewForm] = useState({
    title: '',
    brandId: '',
    type: 'ESTATICA',
    format: '1080x1080',
    copy: '',
    status: 'EN_PRODUCCION',
    assignedToId: ''
  });
  const [creatingPiece, setCreatingPiece] = useState(false);

  const isAdmin = ['ADMIN', 'CUENTAS'].includes(user?.role || '');
  const canManage = ['ADMIN', 'CUENTAS', 'CONTENIDO'].includes(user?.role || '');

  // APERTURA AUTOMÁTICA DEL MODAL DE PIEZA (DESDE EQUIPO O DASHBOARD)
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const targetId = (location.state as any)?.openPieceId || searchParams.get('pieceId');

    if (targetId) {
      api.get(`/pieces/${targetId}`).then(res => {
        if (res.data) {
          setSelected(res.data);
          setComments(res.data.comments || []);
          setEditedCopy(res.data.copy || '');
        }
      }).catch(() => {});
    }
  }, [location.search, location.state]);


  


  


  

  


  // Calcular semanas dinámicas según el mes seleccionado
  const availableWeeks = useMemo(() => {
    if (filterMonth === 'all') return [];
    return getWeeksForMonth(parseInt(filterMonth, 10));
  }, [filterMonth]);

  // Al cambiar de mes, resetear filtro de semana
  const handleMonthChange = (newMonth: string) => {
    setFilterMonth(newMonth);
    setFilterWeek('all');
  };

  useEffect(() => {
    loadData();
  }, []);

  // Auto-abrir modal de la pieza y comentarios al hacer clic en una notificación
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const targetPieceId = params.get('pieceId') || (location.state as any)?.openPieceId;

    if (targetPieceId) {
      api.get(`/pieces/${targetPieceId}`).then(res => {
        if (res.data) {
          setSelected(res.data);
          loadComments(targetPieceId);
        }
      }).catch(() => {
        const found = pieces.find(p => p.id === targetPieceId);
        if (found) {
          setSelected(found);
          loadComments(found.id);
        }
      });
    }
  }, [location.search, location.state, pieces.length]);


  const loadData = async () => {
    setLoading(true);
    try {
      const [pRes, bRes, uRes] = await Promise.all([
        api.get('/pieces'),
        api.get('/brands'),
        api.get('/users').catch(() => ({ data: [] }))
      ]);
      setPieces(Array.isArray(pRes.data) ? pRes.data : []);
      setBrands(Array.isArray(bRes.data) ? bRes.data : []);
      setUsers(Array.isArray(uRes.data) ? uRes.data : []);
    } catch {
      toast.error('Error al cargar contenido');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selected?.id) {
      loadComments(selected.id);
      setEditedCopy(selected.copy || '');
      setIsEditingCopy(false);
    } else {
      setComments([]);
    }
  }, [selected?.id]);

  
  // Cargar archivos de Drive vinculados a Cuadro de Material
  useEffect(() => {
    if (selected?.id) {
      setActiveSlideIdx(0);
      setCurrentDriveFileIdx(0);
      if (selected.type === 'CUADRO_MATERIAL') {
        setLoadingDriveFiles(true);
        api.get(`/pieces/${selected.id}/drive-files`)
          .then(res => {
            setDriveFiles(Array.isArray(res.data?.files) ? res.data.files : []);
          })
          .catch(() => setDriveFiles([]))
          .finally(() => setLoadingDriveFiles(false));
      } else {
        setDriveFiles([]);
      }
    }
  }, [selected?.id, selected?.type]);


  const loadComments = async (pieceId: string) => {
    try {
      const r = await api.get(`/pieces/${pieceId}/comments`);
      setComments(Array.isArray(r.data) ? r.data : []);
    } catch {
      setComments([]);
    }
  };

  
  // Asignar / Reasignar Diseñador Responsable a una Pieza
  
  // Obtener el Diseñador Asignado Responsable de la Pieza
  const getAssignedDesigner = (p: any) => {
    if (!p) return { name: 'Sin asignar', avatar: null, id: null };
    const procUserId = p.processCard?.assignedUserId;
    const fromProcessUser = procUserId ? users.find((u: any) => u.id === procUserId) : null;
    const fromRequest = p.request?.assignedTo;
    const fromUserList = users.find((u: any) => u.id === (p.createdById || p.assignedToId));
    const fromCreated = p.createdBy;

    const assigned = fromProcessUser || fromRequest || fromUserList || fromCreated;
    if (!assigned || !assigned.firstName) return { name: 'Sin asignar', avatar: null, id: null };
    return {
      id: assigned.id,
      name: `${assigned.firstName || ''} ${assigned.lastName || ''}`.trim(),
      avatar: assigned.avatar || null
    };
  };

  
  // Apertura instantánea de pieza desde Notificaciones vía CustomEvent
  useEffect(() => {
    const handleDirectOpen = (e: any) => {
      const pId = e.detail?.pieceId;
      if (pId) {
        api.get(`/pieces/${pId}`).then(res => {
          if (res.data) {
            setSelected(res.data);
            loadComments(pId);
          }
        }).catch(() => {});
      }
    };
    window.addEventListener('open-piece-modal', handleDirectOpen);
    return () => window.removeEventListener('open-piece-modal', handleDirectOpen);
  }, []);

  const handleAssignDesigner = async (pieceId: string, userId: string) => {
    try {
      await api.put(`/pieces/${pieceId}/assign`, { userId });
      const assignedUser = users.find(u => u.id === userId);
      setSelected((prev: any) => prev ? { ...prev, createdById: userId, createdBy: assignedUser } : null);
      setPieces(prev => prev.map(p => p.id === pieceId ? { ...p, createdById: userId, createdBy: assignedUser } : p));
      toast.success('Responsable asignado y notificado');
    } catch {
      toast.error('Error al asignar responsable');
    }
  };

  const handleStatusChange = async (pieceId: string, newStatus: string) => {
    if (isAlejandra && ['APROBADO', 'REVISION_CLIENTE', 'SUBIDO'].includes(newStatus)) {
      toast.error('Función limitada: Las responsabilidades de Alejandra Fernández están enfocadas en Contabilidad y Rendimiento. La aprobación corresponde a Dirección.');
      return;
    }
    const prevPieces = [...pieces];
    setPieces(prev => prev.map(p => p.id === pieceId ? { ...p, status: newStatus } : p));
    if (selected?.id === pieceId) {
      setSelected((prev: any) => prev ? { ...prev, status: newStatus } : null);
    }
    try {
      await api.put(`/pieces/${pieceId}/status`, { status: newStatus });
      toast.success(`Estado: ${STATUS_LABELS[newStatus] || newStatus}`);
      // Recargar comentarios para asegurar persistencia
      loadComments(pieceId);
    } catch {
      setPieces(prevPieces);
      toast.error('Error al actualizar estado');
    }
  };

  // IA Copy Generator
  const handleGenerateAICopy = async () => {
    if (!selected) return;
    setGeneratingCopy(true);
    try {
      const r = await api.post(`/pieces/${selected.id}/generate-copy`);
      if (r.data?.copy) {
        setSelected((prev: any) => ({ ...prev, copy: r.data.copy }));
        setPieces(prev => prev.map(p => p.id === selected.id ? { ...p, copy: r.data.copy } : p));
        setEditedCopy(r.data.copy);
        setIsEditingCopy(false);
        toast.success(' Copy generado con éxito por Gemini');
      }
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Error al generar copy con IA');
    } finally {
      setGeneratingCopy(false);
    }
  };

  const handleSaveCopy = async () => {
    if (!selected) return;
    try {
      await api.patch(`/pieces/${selected.id}/copy`, { copy: editedCopy });
      setSelected((prev: any) => ({ ...prev, copy: editedCopy }));
      setPieces(prev => prev.map(p => p.id === selected.id ? { ...p, copy: editedCopy } : p));
      setIsEditingCopy(false);
      toast.success('Copy guardado');
    } catch {
      toast.error('Error al guardar copy');
    }
  };

  // Comentarios
  const handleSendComment = async () => {
    if (!commentText.trim() || !selected) return;
    setSendingComment(true);
    try {
      const stepValue = selected.type === 'CARRUSEL'
        ? (commentTargetSlide === 'GENERAL' ? 'ALL' : String(activeSlideIdx))
        : (selected.type === 'CUADRO_MATERIAL' ? String(currentDriveFileIdx) : '');

      await api.post(`/pieces/${selected.id}/comment`, {
        content: commentText.trim(),
        step: stepValue
      });
      setCommentText('');
      await loadComments(selected.id);
      toast.success('Comentario agregado');
    } catch {
      toast.error('Error al enviar comentario');
    } finally {
      setSendingComment(false);
    }
  };

  const handleCommentImage = async (file: File) => {
    if (!selected) return;
    setUploadingCommentImg(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const uploadRes = await api.post('/uploads', formData);

      const stepValue = selected.type === 'CARRUSEL'
        ? (commentTargetSlide === 'GENERAL' ? 'ALL' : String(activeSlideIdx))
        : (selected.type === 'CUADRO_MATERIAL' ? String(currentDriveFileIdx) : '');

      await api.post(`/pieces/${selected.id}/comment`, {
        imageUrls: [uploadRes.data.url],
        step: stepValue
      });
      await loadComments(selected.id);
      toast.success('✓ Captura pegada y adjuntada al feedback');
    } catch {
      toast.error('Error al subir imagen pegada');
    } finally {
      setUploadingCommentImg(false);
    }
  };

  const handlePaste = (e: React.ClipboardEvent) => {
    const items = Array.from(e.clipboardData.items);
    const imgItem = items.find(item => item.type.startsWith('image/'));
    if (imgItem) {
      e.preventDefault();
      const file = imgItem.getAsFile();
      if (file) handleCommentImage(file);
    }
  };

  const handleDeleteComment = async (commentId: string) => {
    if (!selected) return;
    try {
      await api.delete(`/pieces/${selected.id}/comment/${commentId}`);
      setComments(prev => prev.filter(c => c.id !== commentId));
      toast.success('Comentario eliminado');
    } catch {
      toast.error('Error al eliminar comentario');
    }
  };

  // Audio
  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream);
      mediaRecorderRef.current = mr;
      audioChunksRef.current = [];
      mr.ondataavailable = (e) => { if (e.data.size > 0) audioChunksRef.current.push(e.data); };
      mr.onstop = async () => {
        const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
        await sendAudioNote(audioBlob);
        stream.getTracks().forEach(t => t.stop());
      };
      mr.start();
      setIsRecording(true);
      setRecSeconds(0);
      timerRef.current = setInterval(() => setRecSeconds(s => s + 1), 1000);
    } catch {
      toast.error('No se pudo acceder al micrófono');
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && isRecording) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
      if (timerRef.current) clearInterval(timerRef.current);
    }
  };

  const cancelRecording = () => {
    if (mediaRecorderRef.current && isRecording) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
      if (timerRef.current) clearInterval(timerRef.current);
      audioChunksRef.current = [];
    }
  };

  const sendAudioNote = async (blob: Blob) => {
    if (!selected) return;
    setSendingAudio(true);
    try {
      const formData = new FormData();
      formData.append('file', blob, 'audio_comment.webm');
      const upRes = await api.post('/uploads', formData);
      await api.post(`/pieces/${selected.id}/comment`, { audioUrl: upRes.data.url });
      await loadComments(selected.id);
      toast.success('Nota de voz enviada');
    } catch {
      toast.error('Error al enviar nota de voz');
    } finally {
      setSendingAudio(false);
      setRecSeconds(0);
    }
  };

  const handleReplaceFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file || !selected) return;
    setUploadingFile(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const upRes = await api.post('/uploads', formData);
      const newUrl = upRes.data.url;

      let updatedFiles: string[] = [];
      let updatedFileUrl = newUrl;

      if (selected.type === 'CARRUSEL') {
        const currentFiles = getFilesArray(selected.files);
        if (currentFiles.length > 0) {
          updatedFiles = [...currentFiles];
          const replaceIdx = (activeSlideIdx >= 0 && activeSlideIdx < updatedFiles.length) ? activeSlideIdx : 0;
          updatedFiles[replaceIdx] = newUrl;
          updatedFileUrl = replaceIdx === 0 ? newUrl : (updatedFiles[0] || newUrl);
        } else {
          updatedFiles = [newUrl];
          updatedFileUrl = newUrl;
        }
      } else {
        updatedFiles = [newUrl];
        updatedFileUrl = newUrl;
      }

      // 1. Guardar en Backend con files y fileUrl actualizados
      await api.patch(`/pieces/${selected.id}/file`, {
        fileUrl: updatedFileUrl,
        files: updatedFiles
      });

      // 2. Actualizar estado local inmediatamente
      setSelected((prev: any) => ({
        ...prev,
        fileUrl: updatedFileUrl,
        files: updatedFiles,
        status: 'REVISION_INTERNA'
      }));

      setPieces(prev => prev.map(p => p.id === selected.id ? {
        ...p,
        fileUrl: updatedFileUrl,
        files: updatedFiles,
        status: 'REVISION_INTERNA'
      } : p));

      toast.success(`Arte actualizado con éxito${selected.type === 'CARRUSEL' ? ` (Diapositiva ${activeSlideIdx + 1})` : ''}`);
    } catch (err: any) {
      console.error('Error al actualizar arte:', err);
      toast.error('Error al actualizar arte');
    } finally {
      setUploadingFile(false);
      if (e.target) e.target.value = '';
    }
  };

  
  // Estados para subida múltiple en creación y edición
  const [newPieceFiles, setNewPieceFiles] = useState<string[]>([]);
  const [assignedTeamIds, setAssignedTeamIds] = useState<string[]>([]);
  const [uploadingMulti, setUploadingMulti] = useState<boolean>(false);
  const [brandFoldersList, setBrandFoldersList] = useState<any[]>([]);
  const [selectedFolderId, setSelectedFolderId] = useState<string>('');
  const multiFileInputRef = useRef<HTMLInputElement>(null);
  const carouselAddFilesRef = useRef<HTMLInputElement>(null);

  // Estados para crear carpeta instantánea dentro del modal
  const [inlineNewFolderName, setInlineNewFolderName] = useState('');
  const [creatingInlineFolder, setCreatingInlineFolder] = useState(false);
  const [showInlineNewFolder, setShowInlineNewFolder] = useState(false);

  // Cargar todas las carpetas de Drive disponibles en la plataforma
  const loadAllDriveFolders = () => {
    api.get('/drive/folders/tree')
      .then(res => {
        const fols = Array.isArray(res.data?.folders) ? res.data.folders : [];
        setBrandFoldersList(fols);
      })
      .catch(() => setBrandFoldersList([]));
  };

  useEffect(() => {
    loadAllDriveFolders();
  }, [showNewModal]);

  // Crear carpeta en Drive directamente desde este modal
  const handleCreateInlineFolder = async () => {
    if (!inlineNewFolderName.trim()) return;
    setCreatingInlineFolder(true);
    try {
      const activeBrand = newForm.brandId || (brands[0]?.id || '');
      const res = await api.post('/drive/folders', {
        name: inlineNewFolderName.trim(),
        brandId: activeBrand
      });
      if (res.data?.id) {
        setSelectedFolderId(res.data.id);
        toast.success(`Carpeta "${inlineNewFolderName}" creada y vinculada`);
        setInlineNewFolderName('');
        setShowInlineNewFolder(false);
        loadAllDriveFolders();
      }
    } catch {
      toast.error('Error al crear la carpeta');
    } finally {
      setCreatingInlineFolder(false);
    }
  };

  // Manejar selección múltiple de archivos de golpe (Hasta 10)
  const handleSelectMultipleFiles = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    if (files.length + newPieceFiles.length > 10) {
      toast.error('Puedes cargar un máximo de 10 archivos por carrusel');
    }

    setUploadingMulti(true);
    const uploadedUrls: string[] = [];

    try {
      for (let i = 0; i < Math.min(files.length, 10 - newPieceFiles.length); i++) {
        const file = files[i];
        const formData = new FormData();
        formData.append('file', file);
        const res = await api.post('/uploads', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        if (res.data?.url || res.data?.fileUrl) {
          uploadedUrls.push(res.data.url || res.data.fileUrl);
        }
      }
      setNewPieceFiles(prev => [...prev, ...uploadedUrls]);
      toast.success(`${uploadedUrls.length} archivo(s) cargado(s) exitosamente`);
    } catch {
      toast.error('Error al subir algunos archivos');
    } finally {
      setUploadingMulti(false);
      if (e.target) e.target.value = '';
    }
  };

  // Carga múltiple dentro de una ficha de carrusel existente
  const handleAddFilesToExistingCarousel = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || !selected) return;

    const currentFiles = getFilesArray(selected.files);
    setUploadingMulti(true);
    const uploadedUrls: string[] = [];

    try {
      for (let i = 0; i < Math.min(files.length, 10 - currentFiles.length); i++) {
        const formData = new FormData();
        formData.append('file', files[i]);
        const res = await api.post('/uploads', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        if (res.data?.url || res.data?.fileUrl) {
          uploadedUrls.push(res.data.url || res.data.fileUrl);
        }
      }
      const updatedList = [...currentFiles, ...uploadedUrls];
      await api.patch(`/pieces/${selected.id}`, { files: updatedList, fileUrl: updatedList[0] });
      setSelected({ ...selected, files: updatedList, fileUrl: updatedList[0] });
      toast.success('Diapositivas agregadas al carrusel');
      loadData();
    } catch {
      toast.error('Error al subir diapositivas');
    } finally {
      setUploadingMulti(false);
      if (e.target) e.target.value = '';
    }
  };


  
  // Estados para Edición de Ficha
  const [editingPiece, setEditingPiece] = useState<any | null>(null);
  useEffect(() => {
    if (editingPiece) {
      api.get('/drive/folders/tree').then(res => {
        setBrandFoldersList(Array.isArray(res.data) ? res.data : []);
      }).catch(() => {});
    }
  }, [editingPiece]);
  const [editFolderId, setEditFolderId] = useState('');
  const [editForm, setEditForm] = useState({
    title: '',
    brandId: '',
    type: 'ESTATICA',
    createdById: '',
    publishDate: ''
  });
  const [savingEdit, setSavingEdit] = useState<boolean>(false);

  // Abrir modal de edición
  
  // ── RECEPTOR RECURSIVO DE ARRASTRE DE CARPETAS (Estilo Google Drive) ──
  const [isDragOver, setIsDragOver] = useState(false);

  // Evitar navegación predeterminada del navegador al arrastrar archivos
  useEffect(() => {
    const handleGlobalDragOver = (e: DragEvent) => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragOver(true);
    };

    const handleGlobalDragLeave = (e: DragEvent) => {
      e.preventDefault();
      e.stopPropagation();
      // Solo desactivar si sale de la ventana del navegador
      if (e.clientX <= 0 || e.clientY <= 0 || e.clientX >= window.innerWidth || e.clientY >= window.innerHeight) {
        setIsDragOver(false);
      }
    };

    const handleGlobalDrop = async (e: DragEvent) => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragOver(false);

      const items = e.dataTransfer?.items;
      if (!items || items.length === 0) return;

      const allFiles: File[] = [];
      for (let i = 0; i < items.length; i++) {
        const item = items[i] as any;
        const entry = typeof item.webkitGetAsEntry === 'function' ? item.webkitGetAsEntry() : null;
        if (entry) {
          const files = await traverseFileTree(entry);
          allFiles.push(...files);
        } else if (items[i].kind === 'file') {
          const file = items[i].getAsFile();
          if (file) allFiles.push(file);
        }
      }

      if (allFiles.length > 0) {
        processFilesForBulkCreation(allFiles);
      }
    };

    window.addEventListener('dragover', handleGlobalDragOver);
    window.addEventListener('dragleave', handleGlobalDragLeave);
    window.addEventListener('drop', handleGlobalDrop);

    return () => {
      window.removeEventListener('dragover', handleGlobalDragOver);
      window.removeEventListener('dragleave', handleGlobalDragLeave);
      window.removeEventListener('drop', handleGlobalDrop);
    };
  }, []);

  const traverseFileTree = async (item: any, path = ''): Promise<File[]> => {
    return new Promise(resolve => {
      if (item.isFile) {
        item.file((file: File) => {
          Object.defineProperty(file, 'webkitRelativePath', {
            value: path ? `${path}/${file.name}` : file.name,
            writable: true
          });
          resolve([file]);
        });
      } else if (item.isDirectory) {
        const dirReader = item.createReader();
        dirReader.readEntries(async (entries: any[]) => {
          const files: File[] = [];
          for (const entry of entries) {
            const nested = await traverseFileTree(entry, path ? `${path}/${item.name}` : item.name);
            files.push(...nested);
          }
          resolve(files);
        });
      } else {
        resolve([]);
      }
    });
  };

  const handlePageDrop = async (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragOver(false);

    const items = e.dataTransfer.items;
    if (!items || items.length === 0) return;

    const allFiles: File[] = [];
    for (let i = 0; i < items.length; i++) {
      const item = items[i] as any;
      const entry = typeof item.webkitGetAsEntry === 'function' ? item.webkitGetAsEntry() : null;
      if (entry) {
        const files = await traverseFileTree(entry);
        allFiles.push(...files);
      } else if (items[i].kind === 'file') {
        const file = items[i].getAsFile();
        if (file) allFiles.push(file);
      }
    }

    if (allFiles.length > 0) {
      processFilesForBulkCreation(allFiles);
    }
  };

      // ── MOTOR INTELIGENTE: SUB-CARPETA INMEDIATA = 1 FICHA INDEPENDIENTE ──
  const processFilesForBulkCreation = (fileList: File[]) => {
    const groups = new Map<string, File[]>();

    const validMediaExts = /\.(png|jpe?g|webp|gif|svg|mp4|mov|webm)$/i;

    fileList.forEach(file => {
      // Ignorar archivos basura de sistema
      if (file.name.startsWith('.') || file.name.toLowerCase().includes('desktop.ini') || file.name.toLowerCase().includes('thumbs.db')) return;
      if (!validMediaExts.test(file.name)) return; // Solo imágenes y videos reales

      const relPath = (file as any).webkitRelativePath || file.name;
      const parts = relPath.split('/').filter(Boolean);

      let groupKey = '';

      if (parts.length > 1) {
        // La subcarpeta inmediata que contiene el archivo (sin importar cuántos niveles haya)
        // Ejemplo: "Genius / Parrilla / D180 / slide1.png" -> groupKey = "D180"
        groupKey = parts[parts.length - 2];
      } else {
        // Archivo suelto en la raíz
        groupKey = file.name.replace(/\.[^/.]+$/, '');
      }

      if (!groups.has(groupKey)) groups.set(groupKey, []);
      groups.get(groupKey)!.push(file);
    });

    const detected: { title: string; type: string; files: File[]; previewUrls: string[] }[] = [];

    groups.forEach((files, title) => {
      // Ordenar numéricamente las diapositivas del carrusel (1, 2, 3, 10...)
      files.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));

      const isVideo = files.some(f => f.type.startsWith('video/') || f.name.toLowerCase().endsWith('.mp4') || f.name.toLowerCase().endsWith('.mov'));
      const isCarousel = files.length > 1;
      const type = isCarousel ? 'CARRUSEL' : isVideo ? 'VIDEO' : 'ESTATICA';

      // Limpiar nombre bonito para el título
      const cleanTitle = title.replace(/[-_]/g, ' ').trim();
      const previewUrls = files.map(f => URL.createObjectURL(f));

      detected.push({ title: cleanTitle, type, files, previewUrls });
    });

    // Ordenar las fichas numéricamente
    detected.sort((a, b) => a.title.localeCompare(b.title, undefined, { numeric: true }));

    setBulkItems(detected);
    setBulkBrandId(filterBrand !== 'all' && filterBrand ? filterBrand : (brands[0]?.id || ''));
    setBulkDesignerId(user?.id || '');
    setShowBulkModal(true);
  };

  const handleBulkInputFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      processFilesForBulkCreation(Array.from(e.target.files));
      e.target.value = '';
    }
  };

  const handleExecuteBulkCreation = async () => {
    if (!bulkBrandId || bulkItems.length === 0) {
      toast.error('Selecciona una marca');
      return;
    }

    setIsProcessingBulk(true);
    setBulkProgressText('Subiendo archivos a Cloudflare R2...');

    try {
      const piecesPayload: any[] = [];
      let currentIdx = 0;

      for (const item of bulkItems) {
        currentIdx++;
        setBulkProgressText(`Subiendo pieza ${currentIdx} de ${bulkItems.length}: "${item.title}"...`);

        const uploadedUrls: string[] = [];
        for (const file of item.files) {
          const fd = new FormData();
          fd.append('file', file);
          const upRes = await api.post('/uploads', fd);
          if (upRes.data?.url) uploadedUrls.push(upRes.data.url);
        }

        piecesPayload.push({
          title: item.title,
          type: item.type,
          files: uploadedUrls,
          fileUrl: uploadedUrls[0] || '',
          publishDate: bulkDate
        });
      }

      setBulkProgressText('Registrando fichas en la base de datos...');
      await api.post('/pieces/bulk', {
        brandId: bulkBrandId,
        createdById: bulkDesignerId,
        materialsBoardId: bulkMaterialsBoardId || null,
        pieces: piecesPayload
      });

      toast.success(`🎉 ¡${piecesPayload.length} fichas creadas con éxito!`);
      setShowBulkModal(false);
      setBulkItems([]);
      loadData();
    } catch (err) {
      toast.error('Error durante la carga masiva');
    } finally {
      setIsProcessingBulk(false);
      setBulkProgressText('');
    }
  };


  // ── AGREGAR NUEVA DIAPOSITIVA A LA FICHA ABIERTA ──
  const [uploadingNewSlide, setUploadingNewSlide] = useState(false);
  const newSlideInputRef = useRef<HTMLInputElement>(null);

  const handleAddNewSlide = async (file: File) => {
    if (!selected) return;
    setUploadingNewSlide(true);
    toast.loading('Subiendo nueva diapositiva a Cloudflare...', { id: 'slide-up' });

    try {
      const fd = new FormData();
      fd.append('file', file);
      const res = await api.post('/uploads', fd);
      const newUrl = res.data.url;

      const currentFiles = Array.isArray(selected.files) && selected.files.length > 0
        ? [...selected.files]
        : (selected.fileUrl ? [selected.fileUrl] : []);

      const updatedFiles = [...currentFiles, newUrl];

      // Actualizar en backend
      const patchRes = await api.patch(`/pieces/${selected.id}`, {
        files: updatedFiles,
        fileUrl: updatedFiles[0],
        type: 'CARRUSEL'
      });

      setSelected((prev: any) => ({
        ...prev,
        files: updatedFiles,
        fileUrl: updatedFiles[0],
        type: 'CARRUSEL'
      }));

      // Actualizar en la lista general de piezas
      setPieces(prev => prev.map(p => p.id === selected.id ? { ...p, files: updatedFiles, fileUrl: updatedFiles[0], type: 'CARRUSEL' } : p));
      setActiveSlideIdx(updatedFiles.length - 1);

      toast.success(`✓ Diapositiva agregada (Total: ${updatedFiles.length})`, { id: 'slide-up' });
    } catch (err) {
      toast.error('Error al agregar diapositiva', { id: 'slide-up' });
    } finally {
      setUploadingNewSlide(false);
    }
  };

  const handleRemoveSlide = async (slideIdxToRemove: number) => {
    if (!selected || !Array.isArray(selected.files) || selected.files.length <= 1) {
      toast.error('No se puede eliminar la única diapositiva de la pieza');
      return;
    }

    if (!window.confirm(`¿Eliminar la diapositiva ${slideIdxToRemove + 1}?`)) return;

    try {
      const updatedFiles = selected.files.filter((_: any, idx: number) => idx !== slideIdxToRemove);
      await api.patch(`/pieces/${selected.id}`, {
        files: updatedFiles,
        fileUrl: updatedFiles[0],
        type: updatedFiles.length > 1 ? 'CARRUSEL' : 'ESTATICA'
      });

      setSelected((prev: any) => ({
        ...prev,
        files: updatedFiles,
        fileUrl: updatedFiles[0],
        type: updatedFiles.length > 1 ? 'CARRUSEL' : 'ESTATICA'
      }));

      setPieces(prev => prev.map(p => p.id === selected.id ? { ...p, files: updatedFiles, fileUrl: updatedFiles[0], type: updatedFiles.length > 1 ? 'CARRUSEL' : 'ESTATICA' } : p));
      setActiveSlideIdx(Math.max(0, slideIdxToRemove - 1));
      toast.success('Diapositiva eliminada');
    } catch {
      toast.error('Error al eliminar diapositiva');
    }
  };

  const handleOpenEditModal = (piece: any) => {
    setEditingPiece(piece);
    setEditFolderId(piece.materialsBoardId || '');
    setEditForm({
      title: piece.title || '',
      brandId: piece.brandId || '',
      type: piece.type || 'ESTATICA',
      createdById: piece.createdById || piece.assignedToId || '',
      publishDate: piece.publishDate ? piece.publishDate.substring(0, 10) : ''
    });
    // Cargar de inmediato todas las 43 carpetas del Drive
    api.get('/drive/folders/tree').then(res => {
      setBrandFoldersList(Array.isArray(res.data) ? res.data : []);
    }).catch(() => {});
  };

  // Guardar edición de la ficha
  const handleSaveEdit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!editingPiece || !editForm.title.trim() || !editForm.brandId) return;

    setSavingEdit(true);
    try {
      const res = await api.patch(`/pieces/${editingPiece.id}`, {
        title: editForm.title.trim(),
        brandId: editForm.brandId,
        type: editForm.type,
        materialsBoardId: editForm.type === 'CUADRO_MATERIAL' ? (editFolderId || null) : null,
        createdById: editForm.createdById || null,
        publishDate: editForm.publishDate ? new Date(editForm.publishDate).toISOString() : null
      });

      toast.success('Ficha actualizada exitosamente');
      if (selected?.id === editingPiece.id) {
        setSelected(res.data);
        if (editForm.type === 'CUADRO_MATERIAL') {
          setLoadingDriveFiles(true);
          api.get(`/pieces/${editingPiece.id}/drive-files`).then(dRes => {
            setDriveFiles(Array.isArray(dRes.data?.files) ? dRes.data.files : []);
            setCurrentDriveFileIdx(0);
          }).finally(() => setLoadingDriveFiles(false));
        }
      }
      setEditingPiece(null);
      loadData();
    } catch {
      toast.error('Error al actualizar la ficha');
    } finally {
      setSavingEdit(false);
    }
  };

  // Eliminar ficha
  const handleDeletePiece = async (pieceId: string) => {
    if (!window.confirm('¿Estás seguro de eliminar esta ficha? Esta acción no se puede deshacer.')) return;

    try {
      await api.delete(`/pieces/${pieceId}`);
      toast.success('Ficha eliminada correctamente');
      if (selected?.id === pieceId) {
        setSelected(null);
      }
      setSelectedPieceIds(prev => prev.filter(id => id !== pieceId));
      loadData();
    } catch {
      toast.error('Error al eliminar la ficha');
    }
  };

  // Selección y Eliminación Masiva
  const toggleSelectPiece = (pieceId: string) => {
    setSelectedPieceIds(prev =>
      prev.includes(pieceId) ? prev.filter(id => id !== pieceId) : [...prev, pieceId]
    );
  };

  const handleSelectAll = () => {
    const allFilteredIds = filteredPieces.map(p => p.id);
    const areAllSelected = allFilteredIds.length > 0 && allFilteredIds.every(id => selectedPieceIds.includes(id));
    if (areAllSelected) {
      setSelectedPieceIds([]);
    } else {
      setSelectedPieceIds(Array.from(new Set([...selectedPieceIds, ...allFilteredIds])));
    }
  };

  const handleClearSelection = () => {
    setSelectedPieceIds([]);
    setIsSelectionMode(false);
  };

  const handleBulkDelete = async () => {
    if (selectedPieceIds.length === 0) return;
    setIsBulkDeleting(true);
    try {
      const res = await api.post('/pieces/bulk-delete', { ids: selectedPieceIds });
      const count = res.data?.count || selectedPieceIds.length;
      toast.success(`${count} ${count === 1 ? 'ficha eliminada' : 'fichas eliminadas'} correctamente`);
      // Optimistic update
      setPieces(prev => prev.filter(p => !selectedPieceIds.includes(p.id)));
      if (selected && selectedPieceIds.includes(selected.id)) {
        setSelected(null);
      }
      setSelectedPieceIds([]);
      setIsSelectionMode(false);
      setShowBulkDeleteModal(false);
      loadData();
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Error al eliminar las fichas');
    } finally {
      setIsBulkDeleting(false);
    }
  };


  const handleCreatePiece = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newForm.title.trim() || !newForm.brandId) {
      toast.error('Completa título y marca');
      return;
    }
    setCreatingPiece(true);
    try {
      const r = await api.post('/pieces', newForm);
      setPieces(prev => [r.data, ...prev]);
      setShowNewModal(false);
      setNewForm({ title: '', brandId: '', type: 'ESTATICA', format: '1080x1080', copy: '', status: 'EN_PRODUCCION', assignedToId: '' });
      toast.success('Pieza creada con éxito');
    } catch {
      toast.error('Error al crear pieza');
    } finally {
      setCreatingPiece(false);
    }
  };

  // FILTRADO BASE (Mes, Semana, Diseñador, Marca, Búsqueda)
  const baseFilteredPieces = pieces.filter(p => {
    const pDate = new Date(p.publishDate || p.createdAt || p.updatedAt);

    // 1. Filtro por Mes
    if (filterMonth !== 'all') {
      const pMonth = pDate.getMonth() + 1;
      if (pMonth !== parseInt(filterMonth, 10)) return false;

      // Filtro por Semana Calendario dentro del mes seleccionado
      if (filterWeek !== 'all') {
        const selectedWeekObj = availableWeeks.find(w => w.id === filterWeek);
        if (selectedWeekObj) {
          if (pDate < selectedWeekObj.start || pDate > selectedWeekObj.end) return false;
        }
      }
    }

    // 2. Filtro por Diseñador / Responsable
    if (filterUser) {
      const respId = p.assignedToId || p.request?.assignedToId || p.createdById;
      if (respId !== filterUser) return false;
    }

    // 3. Filtro por Marca
    if (filterBrand && p.brandId !== filterBrand) return false;

    // 4. Buscador
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      const matchTitle = (p.title || '').toLowerCase().includes(q);
      const matchCopy = (p.copy || '').toLowerCase().includes(q);
      const matchBrand = (p.brand?.name || '').toLowerCase().includes(q);
      if (!matchTitle && !matchCopy && !matchBrand) return false;
    }

    return true;
  });

  // CONTADORES REACTIVOS SEGÚN LOS FILTROS SELECCIONADOS
  const statusCounts = {
    ALL: baseFilteredPieces.length,
    EN_PRODUCCION: baseFilteredPieces.filter(p => p.status === 'EN_PRODUCCION').length,
    REVISION_INTERNA: baseFilteredPieces.filter(p => p.status === 'REVISION_INTERNA').length,
    REVISION_CLIENTE: baseFilteredPieces.filter(p => p.status === 'REVISION_CLIENTE').length,
    APROBADO: baseFilteredPieces.filter(p => p.status === 'APROBADO').length,
  };

  // LISTA FINAL MOSTRADA (Filtrada por la pestaña activa)
  const filteredPieces = filterStatus === 'ALL'
    ? baseFilteredPieces
    : baseFilteredPieces.filter(p => p.status === filterStatus);

  return (
    <div className="zoik-page-container" style={{ display: 'flex', height: '100vh', maxHeight: '100vh', width: '100vw', maxWidth: '100vw', overflow: 'hidden', background: 'radial-gradient(at 10% 10%, rgba(224, 242, 254, 0.4) 0px, transparent 50%), radial-gradient(at 90% 90%, rgba(241, 245, 249, 0.7) 0px, transparent 50%), #f8fafc', fontFamily: '"Montserrat", sans-serif' }}>
      {/* ESTILOS INLINE PARA LIQUID GLASS Y ANIMACIÓN DE VENTANAS DESPLEGABLES */}
      <style>{`
        @keyframes glassDeploy {
          0% {
            opacity: 0;
            transform: scale(0.94) translateY(-8px);
          }
          100% {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }
        .liquid-glass-card {
          background: rgba(255, 255, 255, 0.35);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.65);
          box-shadow: 0 8px 32px 0 rgba(15, 42, 74, 0.04), inset 0 1.5px 2px rgba(255, 255, 255, 0.85);
          transition: all 0.28s cubic-bezier(0.16, 1, 0.3, 1);
        }
        .liquid-glass-card:hover {
          background: rgba(255, 255, 255, 0.55);
          transform: translateY(-4px);
          box-shadow: 0 16px 40px -4px rgba(15, 42, 74, 0.1), inset 0 1.5px 2px rgba(255, 255, 255, 0.95);
          border-color: rgba(0, 112, 243, 0.4);
        }
        .glass-window-popup {
          z-index: 9999;
          background: rgba(255, 255, 255, 0.88);
          backdrop-filter: blur(24px);
          -webkit-backdrop-filter: blur(24px);
          border: 1px solid rgba(255, 255, 255, 0.9);
          box-shadow: 0 20px 45px -10px rgba(15, 42, 74, 0.18), 0 0 1px 1px rgba(255, 255, 255, 0.9), inset 0 1.5px 2px rgba(255, 255, 255, 0.95);
          animation: glassDeploy 0.22s cubic-bezier(0.16, 1, 0.3, 1) forwards;
          transform-origin: top left;
        }
      `}</style>
      <Sidebar />
      <main className="zoik-page-main" style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, overflowY: 'auto' }}>

        {/* CABECERA PRINCIPAL EN LIQUID GLASS */}
        <div style={{
          position: 'relative',
          zIndex: 50,
          background: 'rgba(255, 255, 255, 0.65)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.8)',
          padding: '22px 32px 18px',
          boxShadow: '0 4px 20px -2px rgba(15, 42, 74, 0.04), inset 0 1.5px 2px rgba(255, 255, 255, 0.9)'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px', marginBottom: '18px' }}>
            <div>
              <h1 style={{ margin: 0, fontSize: '22px', fontWeight: 900, color: '#0f2a4a' }}>
                Módulo de Contenido
              </h1>
              <p style={{ margin: '4px 0 0', fontSize: '13px', color: 'rgba(15, 42, 74, 0.5)' }}>
                Supervisa piezas, retroalimenta artes y genera copies con IA
              </p>
            </div>

            {/* FILTROS DINÁMICOS EN LIQUID GLASS */}
            <div ref={dropdownContainerRef} style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', position: 'relative', zIndex: 60 }}>
              {/* Buscador con Animación de Expansión Suave desde la Lupa */}
              <div
                style={{
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  background: 'rgba(255, 255, 255, 0.55)',
                  backdropFilter: 'blur(16px)',
                  WebkitBackdropFilter: 'blur(16px)',
                  border: isSearchExpanded || searchQuery ? '1px solid rgba(0, 112, 243, 0.45)' : '1px solid rgba(255, 255, 255, 0.8)',
                  borderRadius: '14px',
                  padding: '3px',
                  boxShadow: isSearchExpanded || searchQuery
                    ? '0 6px 20px rgba(0, 112, 243, 0.12), inset 0 1px 2px rgba(255, 255, 255, 0.9)'
                    : '0 2px 8px rgba(15, 42, 74, 0.03), inset 0 1px 2px rgba(255, 255, 255, 0.85)',
                  transition: 'all 0.35s cubic-bezier(0.16, 1, 0.3, 1)',
                  width: isSearchExpanded || searchQuery ? '250px' : '38px',
                  height: '38px',
                  boxSizing: 'border-box',
                  overflow: 'hidden'
                }}
              >
                <button
                  type="button"
                  onClick={() => {
                    setIsSearchExpanded(true);
                    searchInputRef.current?.focus();
                  }}
                  style={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '10px',
                    border: 'none',
                    background: 'transparent',
                    color: isSearchExpanded || searchQuery ? '#0070f3' : '#64748b',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    padding: 0,
                    transition: 'color 0.2s ease'
                  }}
                >
                  <IconSearch size={16} />
                </button>
                <input
                  ref={searchInputRef}
                  type="text"
                  value={searchQuery}
                  onFocus={() => setIsSearchExpanded(true)}
                  onBlur={() => { if (!searchQuery) setIsSearchExpanded(false); }}
                  onChange={e => setSearchQuery(e.target.value)}
                  placeholder="Buscar pieza o copy..."
                  style={{
                    border: 'none',
                    background: 'transparent',
                    fontSize: '12px',
                    fontWeight: 600,
                    color: '#0f2a4a',
                    outline: 'none',
                    fontFamily: '"Montserrat", sans-serif',
                    width: '100%',
                    padding: '0 6px',
                    opacity: isSearchExpanded || searchQuery ? 1 : 0,
                    transition: 'opacity 0.22s ease',
                    pointerEvents: isSearchExpanded || searchQuery ? 'auto' : 'none'
                  }}
                />
                {searchQuery && (
                  <button
                    type="button"
                    onClick={() => { setSearchQuery(''); setIsSearchExpanded(false); }}
                    style={{
                      border: 'none',
                      background: 'none',
                      color: '#94a3b8',
                      cursor: 'pointer',
                      padding: '0 6px',
                      fontSize: '14px',
                      lineHeight: 1
                    }}
                  >
                    ×
                  </button>
                )}
              </div>

              {/* Filtro Mes / Año estilo Ventanita Liquid Glass */}
              <div style={{ position: 'relative', zIndex: openGlassDropdown === 'month' ? 80 : 2 }}>
                <button
                  type="button"
                  onClick={() => setOpenGlassDropdown(openGlassDropdown === 'month' ? null : 'month')}
                  style={{
                    padding: '8px 14px',
                    borderRadius: '14px',
                    border: '1px solid rgba(255, 255, 255, 0.8)',
                    background: openGlassDropdown === 'month' ? 'rgba(255, 255, 255, 0.9)' : 'rgba(255, 255, 255, 0.55)',
                    backdropFilter: 'blur(16px)',
                    WebkitBackdropFilter: 'blur(16px)',
                    fontSize: '12px',
                    fontWeight: 700,
                    color: '#0f2a4a',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    boxShadow: '0 2px 8px rgba(15, 42, 74, 0.03), inset 0 1px 2px rgba(255, 255, 255, 0.85)',
                    transition: 'all 0.2s ease',
                    height: '38px',
                    boxSizing: 'border-box'
                  }}
                >
                  <IconCalendar size={15} color="#0070f3" />
                  <span>{filterMonth === 'all' ? 'Todo el año' : MONTH_NAMES[parseInt(filterMonth, 10) - 1]}</span>
                  <span style={{ fontSize: '9px', color: '#64748b', marginLeft: '2px' }}>▼</span>
                </button>
                {openGlassDropdown === 'month' && (
                  <div className="glass-window-popup" style={{ position: 'absolute', top: '44px', left: 0, width: '190px', maxHeight: '260px', overflowY: 'auto', borderRadius: '16px', zIndex: 100, padding: '6px' }}>
                    <button
                      type="button"
                      onClick={() => { handleMonthChange('all'); setOpenGlassDropdown(null); }}
                      style={{ width: '100%', padding: '8px 10px', borderRadius: '10px', border: 'none', background: filterMonth === 'all' ? 'rgba(0, 112, 243, 0.1)' : 'transparent', textAlign: 'left', fontSize: '12px', fontWeight: filterMonth === 'all' ? 800 : 600, color: filterMonth === 'all' ? '#0070f3' : '#0f2a4a', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
                    >
                      <IconCalendar size={14} color="#0070f3" />
                      <span>Todo el año</span>
                    </button>
                    {MONTH_NAMES.map((mName, i) => {
                      const mVal = String(i + 1);
                      const isSel = filterMonth === mVal;
                      return (
                        <button
                          key={mVal}
                          type="button"
                          onClick={() => { handleMonthChange(mVal); setOpenGlassDropdown(null); }}
                          style={{ width: '100%', padding: '8px 10px', borderRadius: '10px', border: 'none', background: isSel ? 'rgba(0, 112, 243, 0.1)' : 'transparent', textAlign: 'left', fontSize: '12px', fontWeight: isSel ? 800 : 600, color: isSel ? '#0070f3' : '#0f2a4a', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                        >
                          <span>{mName}</span>
                          {i + 1 === (new Date().getMonth() + 1) && <span style={{ fontSize: '10px', color: '#10b981', fontWeight: 800 }}>• Actual</span>}
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>

              {/* Filtro Semana Dinámico estilo Ventanita Liquid Glass */}
              <div style={{ position: 'relative', zIndex: openGlassDropdown === 'week' ? 80 : 2 }}>
                <button
                  type="button"
                  disabled={filterMonth === 'all'}
                  onClick={() => setOpenGlassDropdown(openGlassDropdown === 'week' ? null : 'week')}
                  style={{
                    padding: '8px 14px',
                    borderRadius: '14px',
                    border: '1px solid rgba(255, 255, 255, 0.8)',
                    background: filterMonth === 'all' ? 'rgba(241, 245, 249, 0.5)' : (openGlassDropdown === 'week' ? 'rgba(255, 255, 255, 0.9)' : 'rgba(255, 255, 255, 0.55)'),
                    backdropFilter: 'blur(16px)',
                    WebkitBackdropFilter: 'blur(16px)',
                    fontSize: '12px',
                    fontWeight: 700,
                    color: filterMonth === 'all' ? '#94a3b8' : '#0f2a4a',
                    cursor: filterMonth === 'all' ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    boxShadow: '0 2px 8px rgba(15, 42, 74, 0.03), inset 0 1px 2px rgba(255, 255, 255, 0.85)',
                    transition: 'all 0.2s ease',
                    height: '38px',
                    boxSizing: 'border-box'
                  }}
                >
                  <IconCalendarDays size={15} color={filterMonth === 'all' ? '#94a3b8' : '#0070f3'} />
                  <span>{filterWeek === 'all' ? 'Todo el Mes' : (availableWeeks.find(w => w.id === filterWeek)?.label || 'Semana')}</span>
                  <span style={{ fontSize: '9px', color: '#64748b', marginLeft: '2px' }}>▼</span>
                </button>
                {openGlassDropdown === 'week' && filterMonth !== 'all' && (
                  <div className="glass-window-popup" style={{ position: 'absolute', top: '44px', left: 0, width: '230px', maxHeight: '260px', overflowY: 'auto', borderRadius: '16px', zIndex: 100, padding: '6px' }}>
                    <button
                      type="button"
                      onClick={() => { setFilterWeek('all'); setOpenGlassDropdown(null); }}
                      style={{ width: '100%', padding: '8px 10px', borderRadius: '10px', border: 'none', background: filterWeek === 'all' ? 'rgba(0, 112, 243, 0.1)' : 'transparent', textAlign: 'left', fontSize: '12px', fontWeight: filterWeek === 'all' ? 800 : 600, color: filterWeek === 'all' ? '#0070f3' : '#0f2a4a', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
                    >
                      <IconCalendarDays size={14} color="#0070f3" />
                      <span>Todo el Mes</span>
                    </button>
                    {availableWeeks.map(w => {
                      const isSel = filterWeek === w.id;
                      return (
                        <button
                          key={w.id}
                          type="button"
                          onClick={() => { setFilterWeek(w.id); setOpenGlassDropdown(null); }}
                          style={{ width: '100%', padding: '8px 10px', borderRadius: '10px', border: 'none', background: isSel ? 'rgba(0, 112, 243, 0.1)' : 'transparent', textAlign: 'left', fontSize: '12px', fontWeight: isSel ? 800 : 600, color: isSel ? '#0070f3' : '#0f2a4a', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
                        >
                          <span>{w.label}</span>
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>

              {/* Filtro Diseñador / Equipo estilo Ventanita Liquid Glass */}
              <div style={{ position: 'relative', zIndex: openGlassDropdown === 'user' ? 80 : 2 }}>
                <button
                  type="button"
                  onClick={() => setOpenGlassDropdown(openGlassDropdown === 'user' ? null : 'user')}
                  style={{
                    padding: '8px 14px',
                    borderRadius: '14px',
                    border: '1px solid rgba(255, 255, 255, 0.8)',
                    background: openGlassDropdown === 'user' ? 'rgba(255, 255, 255, 0.9)' : 'rgba(255, 255, 255, 0.55)',
                    backdropFilter: 'blur(16px)',
                    WebkitBackdropFilter: 'blur(16px)',
                    fontSize: '12px',
                    fontWeight: 700,
                    color: '#0f2a4a',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    boxShadow: '0 2px 8px rgba(15, 42, 74, 0.03), inset 0 1px 2px rgba(255, 255, 255, 0.85)',
                    transition: 'all 0.2s ease',
                    height: '38px',
                    boxSizing: 'border-box'
                  }}
                >
                  <IconPalette size={15} color="#0070f3" />
                  <span style={{ maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {filterUser ? (users.find(u => u.id === filterUser)?.firstName + ' ' + (users.find(u => u.id === filterUser)?.lastName?.split(' ')[0] || '')) : 'Todo el Equipo'}
                  </span>
                  <span style={{ fontSize: '9px', color: '#64748b', marginLeft: '2px' }}>▼</span>
                </button>
                {openGlassDropdown === 'user' && (
                  <div className="glass-window-popup" style={{ position: 'absolute', top: '44px', left: 0, width: '220px', maxHeight: '260px', overflowY: 'auto', borderRadius: '16px', zIndex: 100, padding: '6px' }}>
                    <button
                      type="button"
                      onClick={() => { setFilterUser(''); setOpenGlassDropdown(null); }}
                      style={{ width: '100%', padding: '8px 10px', borderRadius: '10px', border: 'none', background: !filterUser ? 'rgba(0, 112, 243, 0.1)' : 'transparent', textAlign: 'left', fontSize: '12px', fontWeight: !filterUser ? 800 : 600, color: !filterUser ? '#0070f3' : '#0f2a4a', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
                    >
                      <IconPalette size={14} color="#0070f3" />
                      <span>Todo el Equipo</span>
                    </button>
                    {users.map(u => {
                      const isSel = filterUser === u.id;
                      return (
                        <button
                          key={u.id}
                          type="button"
                          onClick={() => { setFilterUser(u.id); setOpenGlassDropdown(null); }}
                          style={{ width: '100%', padding: '8px 10px', borderRadius: '10px', border: 'none', background: isSel ? 'rgba(0, 112, 243, 0.1)' : 'transparent', textAlign: 'left', fontSize: '12px', fontWeight: isSel ? 800 : 600, color: isSel ? '#0070f3' : '#0f2a4a', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                        >
                          <span>{u.firstName} {u.lastName?.split(' ')[0]}</span>
                          <span style={{ fontSize: '10px', color: '#94a3b8' }}>({u.role})</span>
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>

              {/* Filtro Marca estilo Ventanita Liquid Glass */}
              <div style={{ position: 'relative', zIndex: openGlassDropdown === 'brand' ? 80 : 2 }}>
                <button
                  type="button"
                  onClick={() => setOpenGlassDropdown(openGlassDropdown === 'brand' ? null : 'brand')}
                  style={{
                    padding: '8px 14px',
                    borderRadius: '14px',
                    border: '1px solid rgba(255, 255, 255, 0.8)',
                    background: openGlassDropdown === 'brand' ? 'rgba(255, 255, 255, 0.9)' : 'rgba(255, 255, 255, 0.55)',
                    backdropFilter: 'blur(16px)',
                    WebkitBackdropFilter: 'blur(16px)',
                    fontSize: '12px',
                    fontWeight: 700,
                    color: '#0f2a4a',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    boxShadow: '0 2px 8px rgba(15, 42, 74, 0.03), inset 0 1px 2px rgba(255, 255, 255, 0.85)',
                    transition: 'all 0.2s ease',
                    height: '38px',
                    boxSizing: 'border-box'
                  }}
                >
                  <IconBuilding size={15} color="#0070f3" />
                  <span style={{ maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {filterBrand ? (brands.find(b => b.id === filterBrand)?.name || 'Marca') : 'Todas las Marcas'}
                  </span>
                  <span style={{ fontSize: '9px', color: '#64748b', marginLeft: '2px' }}>▼</span>
                </button>
                {openGlassDropdown === 'brand' && (
                  <div className="glass-window-popup" style={{ position: 'absolute', top: '44px', left: 0, width: '200px', maxHeight: '260px', overflowY: 'auto', borderRadius: '16px', zIndex: 100, padding: '6px' }}>
                    <button
                      type="button"
                      onClick={() => { setFilterBrand(''); setOpenGlassDropdown(null); }}
                      style={{ width: '100%', padding: '8px 10px', borderRadius: '10px', border: 'none', background: !filterBrand ? 'rgba(0, 112, 243, 0.1)' : 'transparent', textAlign: 'left', fontSize: '12px', fontWeight: !filterBrand ? 800 : 600, color: !filterBrand ? '#0070f3' : '#0f2a4a', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
                    >
                      <IconBuilding size={14} color="#0070f3" />
                      <span>Todas las Marcas</span>
                    </button>
                    {brands.map(b => {
                      const isSel = filterBrand === b.id;
                      return (
                        <button
                          key={b.id}
                          type="button"
                          onClick={() => { setFilterBrand(b.id); setOpenGlassDropdown(null); }}
                          style={{ width: '100%', padding: '8px 10px', borderRadius: '10px', border: 'none', background: isSel ? 'rgba(0, 112, 243, 0.1)' : 'transparent', textAlign: 'left', fontSize: '12px', fontWeight: isSel ? 800 : 600, color: isSel ? '#0070f3' : '#0f2a4a', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
                        >
                          <span>{b.name}</span>
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>

              {canManage && (
                <button
                  type="button"
                  onClick={() => {
                    if (isSelectionMode) {
                      handleClearSelection();
                    } else {
                      setIsSelectionMode(true);
                    }
                  }}
                  style={{
                    padding: '8px 16px',
                    borderRadius: '14px',
                    border: isSelectionMode ? '1.5px solid #0070f3' : '1px solid rgba(255, 255, 255, 0.8)',
                    background: isSelectionMode ? 'rgba(0, 112, 243, 0.12)' : 'rgba(255, 255, 255, 0.65)',
                    backdropFilter: 'blur(12px)',
                    color: isSelectionMode ? '#0070f3' : '#0f2a4a',
                    fontWeight: 800,
                    fontSize: '12px',
                    cursor: 'pointer',
                    fontFamily: '"Montserrat", sans-serif',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '7px',
                    boxShadow: isSelectionMode
                      ? '0 4px 14px rgba(0, 112, 243, 0.2), inset 0 1px 1.5px rgba(255, 255, 255, 0.9)'
                      : '0 2px 6px rgba(15, 42, 74, 0.04), inset 0 1px 1.5px rgba(255, 255, 255, 0.85)',
                    transition: 'all 0.2s ease',
                    height: '38px',
                    boxSizing: 'border-box'
                  }}
                  title={isSelectionMode ? "Salir del modo selección" : "Seleccionar múltiples piezas para eliminarlas masivamente"}
                >
                  <IconCheck size={14} color={isSelectionMode ? '#0070f3' : '#64748b'} />
                  <span>{isSelectionMode ? 'Cancelar Selección' : 'Seleccionar'}</span>
                  {selectedPieceIds.length > 0 && (
                    <span style={{
                      background: '#0070f3',
                      color: '#ffffff',
                      fontSize: '10px',
                      fontWeight: 900,
                      padding: '2px 7px',
                      borderRadius: '10px'
                    }}>
                      {selectedPieceIds.length}
                    </span>
                  )}
                </button>
              )}

              {isAdmin && (
                <button
                  onClick={() => setShowNewModal(true)}
                  style={{
                    padding: '8px 18px',
                    borderRadius: '14px',
                    border: '1px solid rgba(255, 255, 255, 0.8)',
                    background: 'rgba(0, 112, 243, 0.95)',
                    backdropFilter: 'blur(12px)',
                    color: 'white',
                    fontWeight: 800,
                    fontSize: '12px',
                    cursor: 'pointer',
                    fontFamily: '"Montserrat", sans-serif',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    boxShadow: '0 2px 6px rgba(15, 42, 74, 0.08), inset 0 1px 1.5px rgba(255, 255, 255, 0.35)',
                    transition: 'all 0.2s ease',
                    height: '38px',
                    boxSizing: 'border-box'
                  }}
                  onMouseEnter={e => (e.currentTarget.style.transform = 'translateY(-2px)')}
                  onMouseLeave={e => (e.currentTarget.style.transform = 'translateY(0)')}
                >
                  <IconPlus size={15} color="#ffffff" />
                  <span>Nueva Pieza</span>
                </button>
              )}
            </div>
          </div>

          {/* PESTAÑAS DE ESTADO EN LIQUID GLASS */}
          <div style={{ display: 'flex', gap: '10px', overflowX: 'auto', paddingBottom: '4px', alignItems: 'center' }}>
            {[
              { id: 'ALL', label: 'Todas las Piezas', count: statusCounts.ALL, activeBg: 'linear-gradient(135deg, rgba(15, 42, 74, 0.95), rgba(15, 42, 74, 0.85))', activeColor: '#ffffff' },
              { id: 'EN_PRODUCCION', label: 'En Producción', count: statusCounts.EN_PRODUCCION, activeBg: 'linear-gradient(135deg, rgba(0, 112, 243, 0.95), rgba(0, 81, 179, 0.9))', activeColor: '#ffffff' },
              { id: 'REVISION_INTERNA', label: 'Revisión Interna', count: statusCounts.REVISION_INTERNA, activeBg: 'linear-gradient(135deg, rgba(43, 176, 230, 0.95), rgba(14, 142, 194, 0.9))', activeColor: '#ffffff' },
              { id: 'REVISION_CLIENTE', label: 'Revisión Cliente', count: statusCounts.REVISION_CLIENTE, activeBg: 'linear-gradient(135deg, rgba(245, 158, 11, 0.95), rgba(217, 119, 6, 0.9))', activeColor: '#ffffff' },
              { id: 'APROBADO', label: 'Aprobadas', count: statusCounts.APROBADO, activeBg: 'linear-gradient(135deg, rgba(16, 185, 129, 0.95), rgba(5, 150, 105, 0.9))', activeColor: '#ffffff' },
            ].map(tab => {
              const active = filterStatus === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => setFilterStatus(tab.id)}
                  style={{
                    padding: '8px 16px',
                    borderRadius: '14px',
                    border: active ? '1px solid rgba(255, 255, 255, 0.7)' : '1px solid rgba(255, 255, 255, 0.65)',
                    background: active ? tab.activeBg : 'rgba(255, 255, 255, 0.45)',
                    backdropFilter: 'blur(16px)',
                    WebkitBackdropFilter: 'blur(16px)',
                    color: active ? tab.activeColor : '#0f2a4a',
                    fontWeight: active ? 800 : 600,
                    fontSize: '12px',
                    cursor: 'pointer',
                    fontFamily: '"Montserrat", sans-serif',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    boxShadow: active
                      ? '0 6px 18px rgba(15, 42, 74, 0.15), inset 0 1.5px 2px rgba(255, 255, 255, 0.5)'
                      : '0 2px 8px rgba(15, 42, 74, 0.03), inset 0 1px 1.5px rgba(255, 255, 255, 0.85)',
                    transform: active ? 'translateY(-1px)' : 'translateY(0)',
                    transition: 'all 0.22s cubic-bezier(0.16, 1, 0.3, 1)',
                    whiteSpace: 'nowrap'
                  }}
                  onMouseEnter={e => {
                    if (!active) {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.background = 'rgba(255, 255, 255, 0.75)';
                    }
                  }}
                  onMouseLeave={e => {
                    if (!active) {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.background = 'rgba(255, 255, 255, 0.45)';
                    }
                  }}
                >
                  <span>{tab.label}</span>
                  <span style={{
                    fontSize: '10px',
                    fontWeight: 800,
                    background: active ? 'rgba(255, 255, 255, 0.25)' : 'rgba(15, 42, 74, 0.08)',
                    color: active ? '#ffffff' : '#0f2a4a',
                    padding: '2px 7px',
                    borderRadius: '10px',
                    backdropFilter: 'blur(6px)'
                  }}>
                    {tab.count}
                  </span>
                </button>
              );
            })}
          </div>
        </div>

        {/* CUADRÍCULA DE PIEZAS */}
        <div style={{
          position: 'relative',
          zIndex: 1,
          padding: '28px 32px',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
          gap: '20px'
        }}>
          {filteredPieces.length === 0 ? (
            <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '60px 0', color: 'rgba(15,42,74,0.3)', fontSize: '14px', fontWeight: 600 }}>
              No se encontraron piezas con los filtros seleccionados
            </div>
          ) : (
            filteredPieces.map(piece => {
              const assignedUser = piece.assignedTo || piece.request?.assignedTo || piece.createdBy;
              const respFirstName = assignedUser?.firstName || 'Sin';
              const respLastName = assignedUser?.lastName || 'asignar';
              const respName = assignedUser ? `${respFirstName} ${respLastName}` : 'Sin asignar';
              const respAvatar = assignedUser?.avatar;
              const stColor = STATUS_COLORS[piece.status] || '#64748b';

              const isSelected = selectedPieceIds.includes(piece.id);

              return (
                <div
                  key={piece.id}
                  onClick={() => {
                    if (isSelectionMode || selectedPieceIds.length > 0) {
                      toggleSelectPiece(piece.id);
                    } else {
                      setSelected(piece);
                    }
                  }}
                  className="liquid-glass-card"
                  style={{
                    borderRadius: '18px',
                    cursor: 'pointer',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    border: isSelected ? '2px solid #0070f3' : undefined,
                    boxShadow: isSelected ? '0 10px 25px rgba(0, 112, 243, 0.22), inset 0 0 0 1px #0070f3' : undefined,
                    transform: isSelected ? 'scale(0.985)' : undefined,
                    transition: 'all 0.2s cubic-bezier(0.16, 1, 0.3, 1)'
                  }}
                >
                  {/* Botones Flotantes de Selección, Edición y Eliminación en Tarjeta */}
                  <div style={{
                    position: 'relative'
                  }}>
                    {/* Checkbox de Selección (Arriba a la Izquierda) */}
                    {canManage && (
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!isSelectionMode) setIsSelectionMode(true);
                          toggleSelectPiece(piece.id);
                        }}
                        title={isSelected ? "Deseleccionar ficha" : "Seleccionar ficha"}
                        style={{
                          position: 'absolute',
                          top: '8px',
                          left: '8px',
                          zIndex: 12,
                          width: '28px',
                          height: '28px',
                          borderRadius: '8px',
                          border: isSelected ? '2px solid #ffffff' : '1.5px solid rgba(15,42,74,0.3)',
                          background: isSelected ? '#0070f3' : (isSelectionMode ? 'rgba(255, 255, 255, 0.95)' : 'rgba(255, 255, 255, 0.88)'),
                          backdropFilter: 'blur(8px)',
                          color: isSelected ? '#ffffff' : 'transparent',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          boxShadow: isSelected ? '0 3px 10px rgba(0, 112, 243, 0.4)' : '0 2px 6px rgba(0,0,0,0.1)',
                          transition: 'all 0.18s cubic-bezier(0.16, 1, 0.3, 1)',
                          padding: 0
                        }}
                      >
                        <IconCheck size={14} color={isSelected ? '#ffffff' : (isSelectionMode ? 'rgba(15,42,74,0.2)' : 'transparent')} />
                      </button>
                    )}

                    <div style={{
                      position: 'absolute',
                      top: '8px',
                      right: '8px',
                      display: 'flex',
                      gap: '4px',
                      zIndex: 10
                    }}>
                      <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); handleOpenEditModal(piece); }}
                        title="Editar Ficha"
                        style={{
                          width: '28px',
                          height: '28px',
                          borderRadius: '8px',
                          border: 'none',
                          background: 'rgba(255, 255, 255, 0.92)',
                          backdropFilter: 'blur(6px)',
                          color: '#0070f3',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                          padding: 0
                        }}
                      >
                        <IconEdit size={13} color="#0070f3" />
                      </button>
                      <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); handleDeletePiece(piece.id); }}
                        title="Eliminar Ficha"
                        style={{
                          width: '28px',
                          height: '28px',
                          borderRadius: '8px',
                          border: 'none',
                          background: 'rgba(255, 255, 255, 0.92)',
                          backdropFilter: 'blur(6px)',
                          color: '#ef4444',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                          padding: 0
                        }}
                      >
                        <IconTrash size={13} color="#ef4444" />
                      </button>
                    </div>

                  {/* Miniatura */}
                  {isImage(piece.fileUrl) ? (
                    <div style={{ width: '100%', height: '150px', background: '#f1f5f9', overflow: 'hidden' }}>
                      <img src={piece.fileUrl} alt={piece.title || 'Arte'} loading="lazy" decoding="async" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </div>
                  ) : isVideo(piece.fileUrl) ? (
                    <div style={{ width: '100%', height: '120px', background: '#0a192f', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '32px' }}>
                      
                    </div>
                  ) : (
                    <div style={{ width: '100%', height: '100px', background: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(15,42,74,0.3)', fontSize: '28px' }}>
                      {FORMAT_ICONS[piece.type] || '📄'}
                    </div>
                  )}

                  </div>

                  <div style={{ padding: '14px 16px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <div>
                      {/* Marca y Estado */}
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                        <span style={{ fontSize: '11px', fontWeight: 800, color: '#2688c9', textTransform: 'uppercase', letterSpacing: '0.3px', maxWidth: '140px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {piece.brand?.name || 'Zoik Analyst'}
                        </span>
                        <span style={{
                          fontSize: '10px',
                          fontWeight: 800,
                          color: stColor,
                          background: `${stColor}15`,
                          padding: '2px 8px',
                          borderRadius: '8px'
                        }}>
                          {STATUS_LABELS[piece.status] || piece.status}
                        </span>
                      </div>

                      {/* Título */}
                      <div style={{ fontSize: '14px', fontWeight: 800, color: '#0f2a4a', lineHeight: 1.4, marginBottom: '12px' }}>
                        {piece.title || 'Sin título'}
                      </div>
                    </div>

                    {/* Footer: Responsable & Formato */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      paddingTop: '10px',
                      borderTop: '1px solid rgba(15, 42, 74, 0.06)'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }} title={`Responsable: ${respName}`}>
                        {respAvatar ? (
                          <img src={respAvatar} alt={respName} style={{ width: '24px', height: '24px', borderRadius: '50%', objectFit: 'cover' }} />
                        ) : (
                          <div style={{
                            width: '24px',
                            height: '24px',
                            borderRadius: '50%',
                            background: '#0f2a4a',
                            color: 'white',
                            fontSize: '10px',
                            fontWeight: 800,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}>
                            {respFirstName[0] || 'U'}
                          </div>
                        )}
                        <span style={{ fontSize: '11px', fontWeight: 700, color: '#0f2a4a' }}>
                          {respFirstName}
                        </span>
                      </div>

                      <div style={{ fontSize: '11px', color: 'rgba(15, 42, 74, 0.4)', display: 'flex', alignItems: 'center', gap: '4px', fontWeight: 600 }}>
                        <span>{FORMAT_ICONS[piece.type] || '📄'}</span>
                        <span><IconMessage size={11} /> {piece.comments?.length || 0}</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>

        {/* MODAL DE DETALLE Y RETROALIMENTACIÓN */}
        {selected && (
          <div
            onClick={(e) => { if (e.target === e.currentTarget) setSelected(null); }}
            style={{
              position: 'fixed',
              top: 0, left: 0, right: 0, bottom: 0,
              background: 'rgba(10, 25, 47, 0.8)',
              backdropFilter: 'blur(8px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000,
              padding: '24px'
            }}
          >
            <div style={{
              background: '#ffffff',
              borderRadius: '24px',
              width: '100%',
              maxWidth: '1320px',
              height: '93vh',
              maxHeight: '940px',
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '0 25px 60px rgba(0,0,0,0.35)',
              overflow: 'hidden',
              position: 'relative'
            }}>
              {/* Header Modal */}
              <div style={{
                padding: '16px 28px',
                borderBottom: '1px solid rgba(15,42,74,0.08)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                background: '#f8fafc',
                flexShrink: 0
              }}>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '4px' }}>
                    <span style={{ fontSize: '12px', fontWeight: 800, color: '#2688c9', textTransform: 'uppercase' }}>
                      {selected.brand?.name || 'Zoik Analyst'}
                    </span>
                    <span style={{
                      padding: '3px 10px',
                      borderRadius: '12px',
                      fontSize: '10px',
                      fontWeight: 800,
                      background: `${STATUS_COLORS[selected.status] || '#64748b'}20`,
                      color: STATUS_COLORS[selected.status] || '#64748b'
                    }}>
                      {STATUS_LABELS[selected.status] || selected.status}
                    </span>
                  </div>
                  <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 900, color: '#0f2a4a' }}>
                    {selected.title || 'Sin título'}
                  </h2>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                  {/* Selector de Diseñador Responsable */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <span style={{ fontSize: '11px', fontWeight: 800, color: 'rgba(15,42,74,0.5)', textTransform: 'uppercase' }}>
                      Responsable:
                    </span>
                    <select
                      value={selected.createdById || selected.assignedToId || ''}
                      onChange={e => handleAssignDesigner(selected.id, e.target.value)}
                      style={{
                        padding: '7px 10px',
                        borderRadius: '8px',
                        border: '1.5px solid #cbd5e1',
                        fontSize: '12px',
                        fontWeight: 700,
                        color: '#0f2a4a',
                        background: 'white',
                        fontFamily: '"Montserrat", sans-serif',
                        cursor: 'pointer'
                      }}
                    >
                      <option value="">Sin asignar</option>
                      {users.map((u: any) => (
                        <option key={u.id} value={u.id}>
                          {u.firstName} {u.lastName} ({u.role})
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Selector de Estado */}
                  <select
                    value={selected.status}
                    disabled={isAlejandra}
                    title={isAlejandra ? 'Modo Contabilidad: la aprobación operativa corresponde a Dirección' : ''}
                    onChange={e => handleStatusChange(selected.id, e.target.value)}
                    style={{
                      padding: '8px 12px',
                      borderRadius: '8px',
                      border: '1.5px solid #cbd5e1',
                      fontSize: '12px',
                      fontWeight: 700,
                      color: '#0f2a4a',
                      background: 'white',
                      fontFamily: '"Montserrat", sans-serif'
                    }}
                  >
                    {STATUS_FLOW.map(s => (
                      <option key={s} value={s}>{STATUS_LABELS[s]}</option>
                    ))}
                  </select>

                  {/* Botones de Editar y Eliminar Ficha dentro del Modal */}
                  <button
                    onClick={() => handleOpenEditModal(selected)}
                    title="Editar Ficha"
                    style={{
                      width: '34px',
                      height: '34px',
                      borderRadius: '8px',
                      border: '1.5px solid #cbd5e1',
                      background: '#ffffff',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#0070f3',
                      padding: 0
                    }}
                  >
                    <IconEdit size={16} color="#0070f3" />
                  </button>

                  <button
                    onClick={() => handleDeletePiece(selected.id)}
                    title="Eliminar Ficha"
                    style={{
                      width: '34px',
                      height: '34px',
                      borderRadius: '8px',
                      border: '1.5px solid #cbd5e1',
                      background: '#ffffff',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#ef4444',
                      padding: 0
                    }}
                  >
                    <IconTrash size={16} color="#ef4444" />
                  </button>

                  <button
                    onClick={() => setSelected(null)}
                    style={{
                      background: 'none',
                      border: 'none',
                      fontSize: '22px',
                      color: 'rgba(15,42,74,0.5)',
                      cursor: 'pointer',
                      padding: '4px 8px',
                      lineHeight: 1
                    }}
                  >
                    ✕
                  </button>
                </div>
              </div>

              {/* Cuerpo Modal: Adaptativo para Carruseles de 10 Slides, Cuadro de Material y Estáticas */}
              <div style={{ flex: 1, display: 'grid', gridTemplateColumns: selected.type === 'CUADRO_MATERIAL' ? '1.55fr 1fr' : '1.45fr 1fr', minHeight: 0, overflow: 'hidden' }}>

                {/* COLUMNA IZQUIERDA: VISOR SECUENCIAL */}
                <div style={{ padding: '20px 24px', overflowY: 'auto', minHeight: 0, borderRight: '1px solid rgba(15,42,74,0.08)', display: 'flex', flexDirection: 'column', gap: '16px' }}>

                  {/* CASO 1: CUADRO DE MATERIAL (VINCULADO AL DRIVE) */}
                  {selected.type === 'CUADRO_MATERIAL' ? (
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', flexWrap: 'wrap', gap: '8px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span style={{ fontSize: '11px', fontWeight: 800, color: '#10b981', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <IconFolder size={14} color="#10b981" /> Cuadro de Material ({driveFiles.length} recursos)
                          </span>
                        </div>
                        <a
                          href={`/drive?folderId=${selected.materialsBoardId || ''}`}
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            padding: '5px 12px',
                            borderRadius: '8px',
                            background: 'rgba(16, 185, 129, 0.1)',
                            color: '#059669',
                            fontSize: '11px',
                            fontWeight: 800,
                            textDecoration: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px'
                          }}
                        >
                          <IconFolder size={13} color="#059669" /> Abrir en Drive
                        </a>
                      </div>

                      {/* Visor Grande del Archivo Actual */}
                      {loadingDriveFiles ? (
                        <div style={{ height: '380px', borderRadius: '16px', background: '#f8fafc', border: '1.5px solid #cbd5e1', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b', fontSize: '13px' }}>
                          Cargando recursos del Drive...
                        </div>
                      ) : driveFiles.length > 0 ? (
                        <div>
                          <div style={{ position: 'relative', borderRadius: '16px', overflow: 'hidden', border: '1.5px solid #cbd5e1', background: '#0a192f', height: '530px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {isImage(driveFiles[currentDriveFileIdx]?.fileUrl) ? (
                              <img
                                onClick={() => setLightboxUrl(driveFiles[currentDriveFileIdx]?.fileUrl)}
                                src={driveFiles[currentDriveFileIdx]?.fileUrl}
                                alt=""
                                style={{ cursor: 'zoom-in', maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                              />
                            ) : isVideo(driveFiles[currentDriveFileIdx]?.fileUrl) ? (
                              <video src={driveFiles[currentDriveFileIdx]?.fileUrl} controls style={{ width: '100%', height: '100%', background: '#000' }} />
                            ) : (
                              <div style={{ textAlign: 'center', color: 'white' }}>
                                <div style={{ fontSize: '32px' }}>📄</div>
                                <div style={{ fontSize: '13px', marginTop: '6px' }}>{driveFiles[currentDriveFileIdx]?.name}</div>
                              </div>
                            )}

                            {/* Controles de Navegación < > */}
                            {driveFiles.length > 1 && (
                              <>
                                <button
                                  onClick={() => setCurrentDriveFileIdx(prev => Math.max(0, prev - 1))}
                                  disabled={currentDriveFileIdx === 0}
                                  style={{
                                    position: 'absolute',
                                    left: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    width: '36px',
                                    height: '36px',
                                    borderRadius: '50%',
                                    border: 'none',
                                    background: 'rgba(255,255,255,0.9)',
                                    color: '#0f2a4a',
                                    cursor: currentDriveFileIdx === 0 ? 'not-allowed' : 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
                                    opacity: currentDriveFileIdx === 0 ? 0.3 : 1
                                  }}
                                >
                                  <IconChevronLeft size={18} />
                                </button>
                                <button
                                  onClick={() => setCurrentDriveFileIdx(prev => Math.min(driveFiles.length - 1, prev + 1))}
                                  disabled={currentDriveFileIdx === driveFiles.length - 1}
                                  style={{
                                    position: 'absolute',
                                    right: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    width: '36px',
                                    height: '36px',
                                    borderRadius: '50%',
                                    border: 'none',
                                    background: 'rgba(255,255,255,0.9)',
                                    color: '#0f2a4a',
                                    cursor: currentDriveFileIdx === driveFiles.length - 1 ? 'not-allowed' : 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
                                    opacity: currentDriveFileIdx === driveFiles.length - 1 ? 0.3 : 1
                                  }}
                                >
                                  <IconChevronRight size={18} />
                                </button>
                              </>
                            )}

                                                        {/* Diseñador que subió el recurso */}
                            {driveFiles[currentDriveFileIdx]?.createdBy && (
                              <div style={{ position: 'absolute', top: '12px', left: '12px', background: 'rgba(15,42,74,0.85)', backdropFilter: 'blur(8px)', color: 'white', padding: '6px 12px', borderRadius: '10px', fontSize: '11px', fontWeight: 800, display: 'flex', alignItems: 'center', gap: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.3)' }}>
                                {driveFiles[currentDriveFileIdx].createdBy.avatar ? (
                                  <img src={driveFiles[currentDriveFileIdx].createdBy.avatar} alt="" style={{ width: '20px', height: '20px', borderRadius: '50%', objectFit: 'cover' }} />
                                ) : (
                                  <div style={{ width: '20px', height: '20px', borderRadius: '50%', background: '#2688c9', color: 'white', fontSize: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {driveFiles[currentDriveFileIdx].createdBy.firstName?.[0] || 'D'}
                                  </div>
                                )}
                                <span>Subido por: {driveFiles[currentDriveFileIdx].createdBy.firstName} {driveFiles[currentDriveFileIdx].createdBy.lastName}</span>
                              </div>
                            )}

                            {/* Badge Indicador de Posición */}
                            <div style={{ position: 'absolute', bottom: '10px', right: '12px', background: 'rgba(0,0,0,0.7)', color: 'white', padding: '4px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: 800 }}>
                              Recurso {currentDriveFileIdx + 1} de {driveFiles.length}
                            </div>
                          </div>

                          {/* Tira Inferior de Miniaturas */}
                          <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', padding: '10px 0 4px' }}>
                            {driveFiles.map((file, fIdx) => (
                              <div
                                key={file.id || fIdx}
                                onClick={() => setCurrentDriveFileIdx(fIdx)}
                                style={{
                                  width: '54px',
                                  height: '54px',
                                  borderRadius: '8px',
                                  overflow: 'hidden',
                                  border: currentDriveFileIdx === fIdx ? '2.5px solid #10b981' : '1.5px solid #cbd5e1',
                                  cursor: 'pointer',
                                  flexShrink: 0,
                                  background: '#f1f5f9',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}
                              >
                                {isImage(file.fileUrl) ? (
                                  <img src={file.fileUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                ) : (
                                  <span style={{ fontSize: '18px' }}>📄</span>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <div style={{ padding: '40px', borderRadius: '16px', background: '#f8fafc', border: '1.5px solid #cbd5e1', textAlign: 'center', color: '#64748b' }}>
                          <IconFolder size={36} color="#10b981" />
                          <div style={{ fontSize: '13px', fontWeight: 700, marginTop: '8px' }}>No hay archivos cargados en la carpeta del Drive</div>
                          <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '4px' }}>Sube imágenes o videos a la carpeta para revisarlos aquí en secuencia.</div>
                        </div>
                      )}
                    </div>
                  ) : selected.type === 'CARRUSEL' ? (

                    /* CASO 2: CARRUSEL DE HASTA 10 DIAPOSITIVAS */
                    <div>
                      {(() => {
                        const carouselFiles = getFilesArray(selected.files);
                        const allFiles = carouselFiles.length > 0 ? carouselFiles : (selected.fileUrl ? [selected.fileUrl] : []);
                        const currentSlideUrl = allFiles[activeSlideIdx] || allFiles[0] || '';

                        return (
                          <div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px', flexWrap: 'wrap', gap: '6px' }}>
                              <span style={{ fontSize: '11px', fontWeight: 800, color: '#8b5cf6', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                <IconLayers size={14} color="#8b5cf6" /> Carrusel ({allFiles.length} de 10 diapositivas)
                              </span>
                              <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                                <button
                                  type="button"
                                  onClick={() => replaceFileRef.current?.click()}
                                  disabled={uploadingFile}
                                  style={{ padding: '4px 10px', borderRadius: '6px', border: '1px solid #8b5cf6', background: 'white', color: '#8b5cf6', fontSize: '11px', fontWeight: 800, cursor: 'pointer' }}
                                >
                                  {uploadingFile ? 'Subiendo...' : `🔄 Reemplazar Diapo ${activeSlideIdx + 1}`}
                                </button>
                                <button
                                  type="button"
                                  onClick={() => carouselAddFilesRef.current?.click()}
                                  disabled={uploadingMulti}
                                  style={{ padding: '4px 10px', borderRadius: '6px', border: 'none', background: '#8b5cf6', color: 'white', fontSize: '11px', fontWeight: 800, cursor: 'pointer' }}
                                >
                                  {uploadingMulti ? 'Subiendo...' : '➕ Subir Contenido (Hasta 10)'}
                                </button>
                                <input
                                  ref={carouselAddFilesRef}
                                  type="file"
                                  multiple
                                  accept="image/*,video/*"
                                  style={{ display: 'none' }}
                                  onChange={handleAddFilesToExistingCarousel}
                                />
                              </div>
                              <span style={{ fontSize: '11px', fontWeight: 800, color: '#0f2a4a', background: 'rgba(139,92,246,0.1)', padding: '3px 8px', borderRadius: '6px' }}>
                                Diapositiva {activeSlideIdx + 1} de {allFiles.length || 1}
                              </span>
                            </div>

                            {/* Visor de Slide Actual */}
                            <div style={{ position: 'relative', borderRadius: '16px', overflow: 'hidden', border: '1.5px solid #cbd5e1', background: '#0a192f', height: '500px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              {isImage(currentSlideUrl) ? (
                                <img
                                  onClick={() => setLightboxUrl(currentSlideUrl)}
                                  src={currentSlideUrl}
                                  alt=""
                                  style={{ cursor: 'zoom-in', maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                />
                              ) : isVideo(currentSlideUrl) ? (
                                <video src={currentSlideUrl} controls style={{ width: '100%', height: '100%', background: '#000' }} />
                              ) : (
                                <div style={{ color: 'white', textAlign: 'center' }}>
                                  <div style={{ fontSize: '32px' }}></div>
                                  <div style={{ fontSize: '13px' }}>Sin diapositiva cargada</div>
                                </div>
                              )}

                              {/* Flechas de Navegación < > */}
                              {allFiles.length > 1 && (
                                <>
                                  <button
                                    onClick={() => setActiveSlideIdx(prev => Math.max(0, prev - 1))}
                                    disabled={activeSlideIdx === 0}
                                    style={{
                                      position: 'absolute',
                                      left: '10px',
                                      top: '50%',
                                      transform: 'translateY(-50%)',
                                      width: '32px',
                                      height: '32px',
                                      borderRadius: '50%',
                                      border: 'none',
                                      background: 'rgba(255,255,255,0.9)',
                                      color: '#0f2a4a',
                                      cursor: activeSlideIdx === 0 ? 'not-allowed' : 'pointer',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      boxShadow: '0 3px 10px rgba(0,0,0,0.2)',
                                      opacity: activeSlideIdx === 0 ? 0.3 : 1
                                    }}
                                  >
                                    <IconChevronLeft size={16} />
                                  </button>
                                  <button
                                    onClick={() => setActiveSlideIdx(prev => Math.min(allFiles.length - 1, prev + 1))}
                                    disabled={activeSlideIdx === allFiles.length - 1}
                                    style={{
                                      position: 'absolute',
                                      right: '10px',
                                      top: '50%',
                                      transform: 'translateY(-50%)',
                                      width: '32px',
                                      height: '32px',
                                      borderRadius: '50%',
                                      border: 'none',
                                      background: 'rgba(255,255,255,0.9)',
                                      color: '#0f2a4a',
                                      cursor: activeSlideIdx === allFiles.length - 1 ? 'not-allowed' : 'pointer',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      boxShadow: '0 3px 10px rgba(0,0,0,0.2)',
                                      opacity: activeSlideIdx === allFiles.length - 1 ? 0.3 : 1
                                    }}
                                  >
                                    <IconChevronRight size={16} />
                                  </button>
                                </>
                              )}
                            </div>

                            {/* Tira Inferior de 10 Slides con Contador de Feedback */}
                            <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', padding: '10px 0 4px', alignItems: 'center' }}>
                              {allFiles.map((fUrl: string, sIdx: number) => {
                                const slideCommentCount = comments.filter((c: any) => c.step === String(sIdx)).length;
                                const isCurrent = activeSlideIdx === sIdx;

                                return (
                                  <div
                                    key={sIdx}
                                    onClick={() => setActiveSlideIdx(sIdx)}
                                    style={{
                                      position: 'relative',
                                      width: '52px',
                                      height: '52px',
                                      borderRadius: '10px',
                                      overflow: 'hidden',
                                      border: isCurrent ? '2.5px solid #8b5cf6' : '1.5px solid #cbd5e1',
                                      cursor: 'pointer',
                                      flexShrink: 0,
                                      background: '#000',
                                      transition: 'all 0.15s'
                                    }}
                                  >
                                    {isImage(fUrl) ? (
                                      <img src={fUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    ) : (
                                      <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '10px', fontWeight: 800 }}>
                                        #{sIdx + 1}
                                      </div>
                                    )}
                                    <div style={{ position: 'absolute', top: '2px', left: '2px', background: 'rgba(0,0,0,0.75)', color: 'white', fontSize: '9px', fontWeight: 900, padding: '1px 4px', borderRadius: '4px' }}>
                                      {sIdx + 1}
                                    </div>
                                    {slideCommentCount > 0 && (
                                      <div style={{ position: 'absolute', bottom: '2px', right: '2px', background: '#ef4444', color: 'white', fontSize: '9px', fontWeight: 900, padding: '1px 4px', borderRadius: '4px', display: 'flex', alignItems: 'center', gap: '2px' }}>
                                        {slideCommentCount}
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })()}
                    </div>
                  ) : (

                    /* CASO 3: POST ESTÁTICO / VIDEO REGULAR */
                    <div>
                      <div style={{ fontSize: '11px', fontWeight: 800, color: 'rgba(15,42,74,0.4)', textTransform: 'uppercase', marginBottom: '8px' }}>
                        Arte / Entregable
                      </div>
                      {isImage(selected.fileUrl) ? (
                        <div style={{ borderRadius: '14px', overflow: 'hidden', border: '1.5px solid #cbd5e1', background: '#0a192f', height: '500px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <img
                            onClick={() => setLightboxUrl(selected.fileUrl)}
                            src={selected.fileUrl}
                            alt={selected.title || 'Arte'}
                            style={{ cursor: 'zoom-in', maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', display: 'block', margin: 'auto' }}
                          />
                        </div>
                      ) : isVideo(selected.fileUrl) ? (
                        <video src={selected.fileUrl} controls style={{ width: '100%', borderRadius: '14px', maxHeight: '500px', background: '#000' }} />
                      ) : (
                        <div style={{ padding: '36px', borderRadius: '14px', background: '#f8fafc', border: '1.5px solid #cbd5e1', textAlign: 'center', color: 'rgba(15,42,74,0.4)' }}>
                          <div style={{ fontSize: '32px', marginBottom: '8px' }}></div>
                          <div style={{ fontSize: '13px', fontWeight: 600 }}>Sin archivo adjunto aún</div>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Acciones de Archivo */}
                  {selected.type !== 'CUADRO_MATERIAL' && (
                    <div style={{ display: 'flex', gap: '10px' }}>
                      {selected.fileUrl && (
                        <button
                          type="button"
                          onClick={() => setLightboxUrl(selected.fileUrl)}
                          style={{
                            padding: '7px 14px',
                            borderRadius: '8px',
                            border: '1.5px solid #cbd5e1',
                            background: 'white',
                            color: '#0f2a4a',
                            fontSize: '12px',
                            fontWeight: 700,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px'
                          }}
                        >
                          <IconEye size={13} /> Ampliar Arte
                        </button>
                      )}
                      <button
                        onClick={() => replaceFileRef.current?.click()}
                        disabled={uploadingFile}
                        style={{
                          padding: '7px 14px',
                          borderRadius: '8px',
                          border: 'none',
                          background: '#2688c9',
                          color: 'white',
                          fontSize: '12px',
                          fontWeight: 700,
                          cursor: 'pointer',
                          fontFamily: '"Montserrat", sans-serif'
                        }}
                      >
                        {uploadingFile ? 'Subiendo...' : selected.type === 'CARRUSEL' ? `🔄 Reemplazar Diapositiva ${activeSlideIdx + 1}` : 'Reemplazar Arte'}
                      </button>
                      <input
                        ref={replaceFileRef}
                        type="file"
                        accept="image/*,video/*"
                        style={{ display: 'none' }}
                        onChange={handleReplaceFile}
                      />
                    </div>
                  )}

                  {/* SECCIÓN DE COPY (EXCLUIDA EN CUADRO DE MATERIAL) */}
                  {selected.type !== 'CUADRO_MATERIAL' && (
                    <div style={{ marginTop: '8px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px', flexWrap: 'wrap', gap: '6px' }}>
                        <div style={{ fontSize: '11px', fontWeight: 800, color: 'rgba(15,42,74,0.4)', textTransform: 'uppercase' }}>
                          Copy / Contenido
                        </div>
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                          {selected.copy && !isEditingCopy && (
                            <>
                              <button
                                onClick={() => { setEditedCopy(selected.copy); setIsEditingCopy(true); }}
                                style={{ background: 'none', border: 'none', color: '#64748b', fontSize: '11px', fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '3px' }}
                              >
                                <IconEdit size={12} /> Editar
                              </button>
                              <button
                                onClick={() => { navigator.clipboard.writeText(selected.copy); toast.success('Copy copiado'); }}
                                style={{ background: 'none', border: 'none', color: '#2688c9', fontSize: '11px', fontWeight: 700, cursor: 'pointer' }}
                              >
                                Copiar
                              </button>
                            </>
                          )}
                          <button
                            onClick={handleGenerateAICopy}
                            disabled={generatingCopy}
                            style={{
                              padding: '5px 12px',
                              borderRadius: '8px',
                              border: 'none',
                              background: 'linear-gradient(135deg, #8b5cf6 0%, #2688c9 100%)',
                              color: 'white',
                              fontSize: '11px',
                              fontWeight: 800,
                              cursor: generatingCopy ? 'not-allowed' : 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px',
                              boxShadow: '0 2px 8px rgba(139, 92, 246, 0.3)'
                            }}
                          >
                            {generatingCopy ? 'Generando con IA...' : 'Generar con IA'}
                          </button>
                        </div>
                      </div>

                      {isEditingCopy ? (
                        <div>
                          <textarea
                            value={editedCopy}
                            onChange={e => setEditedCopy(e.target.value)}
                            rows={5}
                            style={{
                              width: '100%',
                              padding: '12px',
                              borderRadius: '12px',
                              border: '1px solid #2688c9',
                              fontSize: '13px',
                              fontFamily: '"Montserrat", sans-serif',
                              lineHeight: 1.6,
                              boxSizing: 'border-box' as any,
                              outline: 'none',
                              marginBottom: '8px'
                            }}
                          />
                          <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                            <button
                              onClick={() => setIsEditingCopy(false)}
                              style={{ padding: '6px 12px', borderRadius: '8px', border: '1px solid #cbd5e1', background: 'white', fontSize: '12px', fontWeight: 600, cursor: 'pointer' }}
                            >
                              Cancelar
                            </button>
                            <button
                              onClick={handleSaveCopy}
                              style={{ padding: '6px 14px', borderRadius: '8px', border: 'none', background: '#2688c9', color: 'white', fontSize: '12px', fontWeight: 700, cursor: 'pointer' }}
                            >
                              Guardar Copy
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div style={{
                          padding: '12px 14px',
                          borderRadius: '12px',
                          background: '#f8fafc',
                          border: '1.5px solid #cbd5e1',
                          fontSize: '12px',
                          color: '#0f2a4a',
                          lineHeight: 1.6,
                          whiteSpace: 'pre-wrap',
                          maxHeight: '140px',
                          overflowY: 'auto'
                        }}>
                          {selected.copy || 'Sin copy registrado para esta pieza. Haz clic en "Generar con IA" para crear uno automáticamente.'}
                        </div>
                      )}
                    </div>
                  )}

                </div>

                {/* COLUMNA DERECHA: RETROALIMENTACIÓN INTELIGENTE */}
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%', maxHeight: '100%', minHeight: 0, background: '#fafbfc', overflow: 'hidden' }}>
                  
                  {/* Cabecera de Retroalimentación con Filtro Contextual de Slides */}
                  <div style={{ padding: '14px 18px', borderBottom: '1px solid rgba(15,42,74,0.06)', background: '#ffffff', flexShrink: 0 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: selected.type === 'CARRUSEL' ? '8px' : '0' }}>
                      <span style={{ fontWeight: 900, fontSize: '13px', color: '#0f2a4a', display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <IconMessage size={15} color="#0070f3" /> Retroalimentación & Ajustes ({comments.length})
                      </span>
                    </div>

                    {/* Filtros de Pestañas de Comentarios para Carrusel */}
                    {selected.type === 'CARRUSEL' && (
                      <div style={{ display: 'flex', gap: '6px' }}>
                        <button
                          onClick={() => setSlideCommentFilter('CURRENT')}
                          style={{
                            padding: '4px 10px',
                            borderRadius: '6px',
                            border: 'none',
                            background: slideCommentFilter === 'CURRENT' ? '#8b5cf6' : 'rgba(15,42,74,0.05)',
                            color: slideCommentFilter === 'CURRENT' ? '#ffffff' : '#0f2a4a',
                            fontSize: '11px',
                            fontWeight: 800,
                            cursor: 'pointer'
                          }}
                        >
                          Diapositiva {activeSlideIdx + 1} ({comments.filter((c: any) => c.step === String(activeSlideIdx)).length})
                        </button>
                        <button
                          onClick={() => setSlideCommentFilter('ALL')}
                          style={{
                            padding: '4px 10px',
                            borderRadius: '6px',
                            border: 'none',
                            background: slideCommentFilter === 'ALL' ? '#8b5cf6' : 'rgba(15,42,74,0.05)',
                            color: slideCommentFilter === 'ALL' ? '#ffffff' : '#0f2a4a',
                            fontSize: '11px',
                            fontWeight: 800,
                            cursor: 'pointer'
                          }}
                        >
                          Todas ({comments.length})
                        </button>
                      </div>
                    )}
                  </div>

                  {/* Lista de Comentarios */}
                  <div style={{ flex: 1, minHeight: 0, padding: '16px 20px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {(() => {
                      const displayedComments = selected.type === 'CARRUSEL' && slideCommentFilter === 'CURRENT'
                        ? comments.filter((c: any) => c.step === String(activeSlideIdx) || c.step === 'ALL' || !c.step)
                        : comments;

                      if (displayedComments.length === 0) {
                        return (
                          <div style={{ textAlign: 'center', color: 'rgba(15,42,74,0.35)', fontSize: '12px', padding: '40px 0' }}>
                            {selected.type === 'CARRUSEL' && slideCommentFilter === 'CURRENT'
                              ? `No hay comentarios en la Diapositiva ${activeSlideIdx + 1}.`
                              : 'No hay comentarios todavía.'}
                            <br />Sé el primero en retroalimentar.
                          </div>
                        );
                      }

                      return displayedComments.map((c: any) => {
                        const authorName = c.user ? `${c.user.firstName || ''} ${c.user.lastName || ''}`.trim() : 'Usuario';
                        const authorInit = c.user?.firstName?.[0] || 'U';
                        const imgList = parseImageUrls(c.imageUrls);

                        return (
                          <div key={c.id} style={{ background: 'white', borderRadius: '12px', padding: '12px', border: '1.5px solid #cbd5e1', boxShadow: '0 1px 4px rgba(0,0,0,0.02)' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <div style={{ width: '22px', height: '22px', borderRadius: '50%', background: '#2688c9', color: 'white', fontSize: '10px', fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  {authorInit}
                                </div>
                                <span style={{ fontSize: '12px', fontWeight: 800, color: '#0f2a4a' }}>
                                  {authorName}
                                </span>
                                {c.step && c.step !== 'ALL' && c.step !== '' && (
                                  <span style={{ fontSize: '9px', fontWeight: 900, background: 'rgba(139,92,246,0.12)', color: '#8b5cf6', padding: '2px 6px', borderRadius: '4px' }}>
                                    Slide {parseInt(c.step, 10) + 1}
                                  </span>
                                )}
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <span style={{ fontSize: '10px', color: 'rgba(15,42,74,0.35)' }}>
                                  {c.createdAt ? new Date(c.createdAt).toLocaleDateString('es-CO', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : ''}
                                </span>
                                {(user?.id === c.userId || isAdmin) && (
                                  <button onClick={() => handleDeleteComment(c.id)} style={{ background: 'none', border: 'none', color: 'rgba(15,42,74,0.25)', cursor: 'pointer', fontSize: '14px' }}>×</button>
                                )}
                              </div>
                            </div>

                            {c.content && (
                              <div style={{ fontSize: '12px', color: '#0f2a4a', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
                                {c.content}
                              </div>
                            )}

                            {imgList.map((url: string, i: number) => (
                              <div key={i} onClick={() => setLightboxUrl(url)} style={{ cursor: 'zoom-in', display: 'inline-block', marginTop: '6px' }}>
                                <img src={url} alt="Captura" style={{ maxWidth: '100%', borderRadius: '8px', maxHeight: '180px', objectFit: 'cover' }} />
                              </div>
                            ))}

                            {c.audioUrl && (
                              <div style={{ marginTop: '8px' }}>
                                <audio src={c.audioUrl} controls style={{ width: '100%', height: '36px' }} />
                              </div>
                            )}
                          </div>
                        );
                      });
                    })()}
                  </div>

                  {/* Input de Comentarios con Soporte de Slide y Grabador de Voz */}
                  <div style={{ padding: '12px 18px', borderTop: '1px solid rgba(15,42,74,0.08)', background: 'white', flexShrink: 0 }}>
                    {/* Selector de Destino para Carrusel */}
                    {selected.type === 'CARRUSEL' && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                        <span style={{ fontSize: '10px', fontWeight: 800, color: 'rgba(15,42,74,0.5)', textTransform: 'uppercase' }}>Comentar en:</span>
                        <select
                          value={commentTargetSlide}
                          onChange={e => setCommentTargetSlide(e.target.value)}
                          style={{ fontSize: '11px', fontWeight: 700, padding: '3px 8px', borderRadius: '6px', border: '1px solid #cbd5e1', color: '#8b5cf6', background: '#faf5ff' }}
                        >
                          <option value="CURRENT">Diapositiva {activeSlideIdx + 1} (Actual)</option>
                          <option value="GENERAL">General (Todo el Carrusel)</option>
                        </select>
                      </div>
                    )}

                    {isRecording ? (
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'rgba(239,68,68,0.08)', padding: '10px 14px', borderRadius: '10px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#ef4444', fontWeight: 700, fontSize: '13px' }}>
                          Grabando: {recSeconds}s
                        </div>
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <button onClick={cancelRecording} style={{ padding: '5px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', background: 'white', fontSize: '11px', cursor: 'pointer' }}>Cancelar</button>
                          <button onClick={stopRecording} disabled={sendingAudio} style={{ padding: '5px 12px', borderRadius: '6px', border: 'none', background: '#ef4444', color: 'white', fontWeight: 700, fontSize: '11px', cursor: 'pointer' }}>{sendingAudio ? 'Enviando...' : 'Enviar Audio ✓'}</button>
                        </div>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <input
                          type="text"
                          value={commentText}
                          onChange={e => setCommentText(e.target.value)}
                          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); handleSendComment(); } }}
                          onPaste={handlePaste}
                          placeholder={selected.type === 'CARRUSEL' ? `Ajuste para Slide ${activeSlideIdx + 1}...` : "Escribe una nota o pega captura (Ctrl+V)..."}
                          style={{
                            flex: 1,
                            padding: '9px 12px',
                            borderRadius: '10px',
                            border: '1.5px solid #cbd5e1',
                            fontSize: '12px',
                            fontFamily: '"Montserrat", sans-serif',
                            outline: 'none'
                          }}
                        />
                        <button
                          type="button"
                          onClick={() => commentImgRef.current?.click()}
                          title="Adjuntar imagen"
                          style={{ width: '34px', height: '34px', borderRadius: '8px', border: '1.5px solid #cbd5e1', background: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        >
                          
                        </button>
                        <input
                          ref={commentImgRef}
                          type="file"
                          accept="image/*"
                          style={{ display: 'none' }}
                          onChange={e => {
                            const file = e.target.files?.[0];
                            if (file) handleCommentImage(file);
                            if (e.target) e.target.value = '';
                          }}
                        />
                        <button
                          type="button"
                          onClick={startRecording}
                          title="Grabar nota de voz"
                          style={{ width: '34px', height: '34px', borderRadius: '8px', border: '1.5px solid #cbd5e1', background: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ef4444' }}
                        >
                          🎤
                        </button>
                        <button
                          onClick={handleSendComment}
                          disabled={sendingComment || !commentText.trim()}
                          style={{
                            padding: '9px 14px',
                            borderRadius: '10px',
                            border: 'none',
                            background: '#0070f3',
                            color: 'white',
                            fontWeight: 800,
                            fontSize: '12px',
                            cursor: sendingComment || !commentText.trim() ? 'not-allowed' : 'pointer',
                            opacity: sendingComment || !commentText.trim() ? 0.6 : 1
                          }}
                        >
                          Enviar
                        </button>
                      </div>
                    )}
                  </div>

                </div>

              </div>
            </div>
          </div>
        )}

        
        {/* MODAL DE EDICIÓN DE FICHA */}
        {editingPiece && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(10,25,47,0.75)',
            backdropFilter: 'blur(8px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1100,
            padding: '20px'
          }}>
            <div style={{ background: 'white', borderRadius: '20px', padding: '28px 32px', width: '100%', maxWidth: '480px', boxShadow: '0 20px 50px rgba(0,0,0,0.3)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '18px' }}>
                <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 900, color: '#0f2a4a', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <IconEdit size={18} color="#0070f3" /> Editar Ficha
                </h2>
                <button onClick={() => setEditingPiece(null)} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#64748b' }}>×</button>
              </div>

              <form onSubmit={handleSaveEdit}>
                <div style={{ marginBottom: '14px' }}>
                  <label style={{ display: 'block', fontSize: '11px', fontWeight: 800, color: 'rgba(15,42,74,0.6)', textTransform: 'uppercase', marginBottom: '6px' }}>Título de la Ficha</label>
                  <input
                    value={editForm.title}
                    onChange={e => setEditForm({ ...editForm, title: e.target.value })}
                    required
                    style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1.5px solid #cbd5e1', fontSize: '13px', fontWeight: 600, boxSizing: 'border-box' as any }}
                  />
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '14px' }}>
                  <div>
                    <label style={{ display: 'block', fontSize: '11px', fontWeight: 800, color: 'rgba(15,42,74,0.6)', textTransform: 'uppercase', marginBottom: '6px' }}>Marca</label>
                    <select
                      value={editForm.brandId}
                      onChange={e => setEditForm({ ...editForm, brandId: e.target.value })}
                      required
                      style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1.5px solid #cbd5e1', fontSize: '13px', boxSizing: 'border-box' as any }}
                    >
                      {brands.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: '11px', fontWeight: 800, color: 'rgba(15,42,74,0.6)', textTransform: 'uppercase', marginBottom: '6px' }}>Formato</label>
                    <select
                      value={editForm.type}
                      onChange={e => setEditForm({ ...editForm, type: e.target.value })}
                      style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1.5px solid #cbd5e1', fontSize: '13px', fontWeight: 700, boxSizing: 'border-box' as any }}
                    >
                      <option value="ESTATICA">Post Estático</option>
                      <option value="CARRUSEL">Carrusel</option>
                      <option value="VIDEO">Video / Reel</option>
                      <option value="CUADRO_MATERIAL">Cuadro de Material</option>
                      <option value="ANIMACION">Animación</option>
                    </select>
                  </div>
                </div>

                {/* Si es Cuadro de Material, permitir vincular / cambiar carpeta de Drive en Edición */}
                {editForm.type === 'CUADRO_MATERIAL' && (
                  <div style={{ marginBottom: '14px', background: '#f0fdf4', padding: '14px', borderRadius: '12px', border: '1.5px solid #86efac' }}>
                    <label style={{ display: 'block', fontSize: '11px', fontWeight: 800, color: '#166534', textTransform: 'uppercase', marginBottom: '6px' }}>
                      <IconFolder size={13} color="#166534" /> Carpeta de Drive Vinculada ({brandFoldersList.length} disponibles)
                    </label>
                    <select
                      value={editFolderId}
                      onChange={e => setEditFolderId(e.target.value)}
                      style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1.5px solid #86efac', fontSize: '13px', fontWeight: 700, background: 'white', color: '#0f2a4a', boxSizing: 'border-box' as any }}
                    >
                      <option value="">-- Selecciona la carpeta con las imágenes --</option>
                      {brandFoldersList.map(fol => (
                        <option key={fol.id} value={fol.id}>
                          📁 {fol.fullPath || fol.name} ({fol.filesCount || 0} archivos)
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div style={{ marginBottom: '14px' }}>
                  <label style={{ display: 'block', fontSize: '11px', fontWeight: 800, color: 'rgba(15,42,74,0.6)', textTransform: 'uppercase', marginBottom: '6px' }}>Diseñador Responsable</label>
                  <select
                    value={editForm.createdById}
                    onChange={e => setEditForm({ ...editForm, createdById: e.target.value })}
                    style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1.5px solid #cbd5e1', fontSize: '13px', boxSizing: 'border-box' as any }}
                  >
                    <option value="">Sin asignar</option>
                    {users.map(u => <option key={u.id} value={u.id}>{u.firstName} {u.lastName} ({u.role})</option>)}
                  </select>
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <label style={{ display: 'block', fontSize: '11px', fontWeight: 800, color: 'rgba(15,42,74,0.6)', textTransform: 'uppercase', marginBottom: '6px' }}>Fecha de Publicación / Entrega</label>
                  <input
                    type="date"
                    value={editForm.publishDate}
                    onChange={e => setEditForm({ ...editForm, publishDate: e.target.value })}
                    style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1.5px solid #cbd5e1', fontSize: '13px', boxSizing: 'border-box' as any }}
                  />
                </div>

                <div style={{ display: 'flex', gap: '10px' }}>
                  <button type="button" onClick={() => setEditingPiece(null)} style={{ flex: 1, padding: '11px', borderRadius: '10px', border: '1px solid #cbd5e1', background: 'white', fontWeight: 700, fontSize: '13px', cursor: 'pointer' }}>Cancelar</button>
                  <button type="submit" disabled={savingEdit} style={{ flex: 1, padding: '11px', borderRadius: '10px', border: 'none', background: '#0070f3', color: 'white', fontWeight: 700, fontSize: '13px', cursor: 'pointer' }}>{savingEdit ? 'Guardando...' : 'Guardar Cambios'}</button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* MODAL LIGHTBOX EN PANTALLA COMPLETA */}
        {lightboxUrl && (
          <div
            onClick={() => setLightboxUrl(null)}
            style={{
              position: 'fixed',
              top: 0, left: 0, right: 0, bottom: 0,
              background: 'rgba(5, 13, 26, 0.92)',
              backdropFilter: 'blur(14px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 2000,
              padding: '30px'
            }}
          >
            <div onClick={e => e.stopPropagation()} style={{ position: 'relative', maxWidth: '92vw', maxHeight: '92vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <button
                onClick={() => setLightboxUrl(null)}
                style={{
                  position: 'absolute',
                  top: '-45px',
                  right: '0px',
                  background: 'rgba(255,255,255,0.15)',
                  border: 'none',
                  color: 'white',
                  borderRadius: '50%',
                  width: '36px',
                  height: '36px',
                  fontSize: '18px',
                  fontWeight: 800,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                ✕
              </button>

              {isImage(lightboxUrl) ? (
                <img src={lightboxUrl} alt="Vista previa original" style={{ maxWidth: '90vw', maxHeight: '85vh', objectFit: 'contain', borderRadius: '12px', boxShadow: '0 20px 60px rgba(0,0,0,0.6)' }} />
              ) : isVideo(lightboxUrl) ? (
                <video src={lightboxUrl} controls autoPlay style={{ maxWidth: '90vw', maxHeight: '85vh', borderRadius: '12px', boxShadow: '0 20px 60px rgba(0,0,0,0.6)' }} />
              ) : (
                <div style={{ background: 'white', padding: '40px', borderRadius: '16px' }}>
                  <a href={lightboxUrl} target="_blank" rel="noreferrer" style={{ color: '#2688c9', fontWeight: 700 }}>Descargar Archivo</a>
                </div>
              )}
            </div>
          </div>
        )}

              {/* MODAL DE CONFIRMACIÓN DE CARGA MASIVA DE FICHAS */}
      {showBulkModal && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(10,25,47,0.75)',
          backdropFilter: 'blur(8px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2500,
          padding: '20px'
        }}>
          <div style={{ background: 'white', borderRadius: '22px', padding: '30px 34px', width: '100%', maxWidth: '640px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 25px 60px rgba(0,0,0,0.35)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '18px' }}>
              <div>
                <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 900, color: '#0f2a4a', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  ⚡ Carga Masiva de Contenido ({bulkItems.length} fichas detectadas)
                </h2>
                <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#64748b' }}>Revisa la configuración para crear todas las fichas en 1 solo paso.</p>
              </div>
              <button onClick={() => { if (!isProcessingBulk) setShowBulkModal(false); }} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#64748b' }}>×</button>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginBottom: '16px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '11px', fontWeight: 800, color: 'rgba(15,42,74,0.6)', textTransform: 'uppercase', marginBottom: '6px' }}>Marca de las Piezas</label>
                <select
                  value={bulkBrandId}
                  onChange={e => setBulkBrandId(e.target.value)}
                  style={{ width: '100%', padding: '10px 12px', borderRadius: '10px', border: '1.5px solid #cbd5e1', fontSize: '13px', fontWeight: 700, color: '#0f2a4a', background: 'white' }}
                >
                  {brands.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
                </select>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '11px', fontWeight: 800, color: 'rgba(15,42,74,0.6)', textTransform: 'uppercase', marginBottom: '6px' }}>Diseñador Responsable</label>
                <select
                  value={bulkDesignerId}
                  onChange={e => setBulkDesignerId(e.target.value)}
                  style={{ width: '100%', padding: '10px 12px', borderRadius: '10px', border: '1.5px solid #cbd5e1', fontSize: '13px', fontWeight: 700, color: '#0f2a4a', background: 'white' }}
                >
                  {users.map(u => <option key={u.id} value={u.id}>{u.firstName} {u.lastName} ({u.role})</option>)}
                </select>
              </div>
            </div>

            {/* Selector de Cuadro de Material o Proceso */}
            <div style={{ marginBottom: '16px', background: '#f8fafc', padding: '12px 14px', borderRadius: '12px', border: '1.5px solid #e2e8f0' }}>
              <label style={{ display: 'block', fontSize: '11px', fontWeight: 800, color: '#0f2a4a', textTransform: 'uppercase', marginBottom: '6px' }}>
                📦 Cuadro de Material / Proceso (Opcional):
              </label>
              <select
                value={bulkMaterialsBoardId}
                onChange={e => setBulkMaterialsBoardId(e.target.value)}
                style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1.5px solid #cbd5e1', fontSize: '13px', fontWeight: 700, color: '#0f2a4a', background: 'white' }}
              >
                <option value="">-- Ninguno (Crear fichas sueltas sin cuadro) --</option>
                {brandCuadros.map(c => (
                  <option key={c.id} value={c.id}>
                    {c.type === 'CUADRO_MATERIALES' ? '📦 Cuadro: ' : '📋 Parrilla: '} {c.name}
                  </option>
                ))}
              </select>
              <div style={{ fontSize: '11px', color: '#64748b', marginTop: '4px' }}>
                Si seleccionas un cuadro, todas las piezas se guardarán y enlazarán directamente a él.
              </div>
            </div>

            <div style={{ marginBottom: '18px' }}>
              <label style={{ display: 'block', fontSize: '11px', fontWeight: 800, color: 'rgba(15,42,74,0.6)', textTransform: 'uppercase', marginBottom: '6px' }}>Fecha de Publicación / Mes</label>
              <input
                type="date"
                value={bulkDate}
                onChange={e => setBulkDate(e.target.value)}
                style={{ width: '100%', padding: '10px 12px', borderRadius: '10px', border: '1.5px solid #cbd5e1', fontSize: '13px', fontWeight: 600, boxSizing: 'border-box' as any }}
              />
            </div>

            {/* Vista previa de las fichas detectadas */}
            <div style={{ marginBottom: '22px' }}>
              <label style={{ display: 'block', fontSize: '11px', fontWeight: 800, color: 'rgba(15,42,74,0.6)', textTransform: 'uppercase', marginBottom: '8px' }}>
                Fichas a Crear ({bulkItems.length}):
              </label>
              <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1.5px solid #e2e8f0', borderRadius: '12px', padding: '8px', background: '#f8fafc', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {bulkItems.map((item, idx) => (
                  <div key={idx} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', background: 'white', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', overflow: 'hidden' }}>
                      <img src={item.previewUrls[0]} alt="" style={{ width: '36px', height: '36px', borderRadius: '6px', objectFit: 'cover' }} />
                      <div style={{ overflow: 'hidden' }}>
                        <div style={{ fontSize: '12px', fontWeight: 800, color: '#0f2a4a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '280px' }}>{item.title}</div>
                        <div style={{ fontSize: '10px', color: '#64748b', fontWeight: 600 }}>{item.files.length} archivo(s)</div>
                      </div>
                    </div>
                    <span style={{ fontSize: '10px', fontWeight: 900, background: item.type === 'CARRUSEL' ? '#f3e8ff' : '#eff6ff', color: item.type === 'CARRUSEL' ? '#7e22ce' : '#0070f3', padding: '3px 8px', borderRadius: '6px' }}>
                      {item.type}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Estado de Progreso */}
            {isProcessingBulk && bulkProgressText && (
              <div style={{ marginBottom: '16px', padding: '12px 16px', borderRadius: '12px', background: '#eff6ff', border: '1px solid #bfdbfe', display: 'flex', alignItems: 'center', gap: '10px', color: '#1e40af', fontSize: '12px', fontWeight: 800 }}>
                <div style={{ width: '14px', height: '14px', border: '2px solid #93c5fd', borderTop: '2px solid #1e40af', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
                <span>{bulkProgressText}</span>
              </div>
            )}

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button
                type="button"
                onClick={() => setShowBulkModal(false)}
                disabled={isProcessingBulk}
                style={{ padding: '12px 20px', borderRadius: '10px', border: '1px solid #cbd5e1', background: 'white', fontWeight: 700, fontSize: '13px', cursor: 'pointer' }}
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={handleExecuteBulkCreation}
                disabled={isProcessingBulk || bulkItems.length === 0}
                style={{
                  padding: '12px 24px',
                  borderRadius: '10px',
                  border: 'none',
                  background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                  color: 'white',
                  fontWeight: 900,
                  fontSize: '13px',
                  cursor: 'pointer',
                  boxShadow: '0 4px 14px rgba(16, 185, 129, 0.3)'
                }}
              >
                {isProcessingBulk ? 'Procesando...' : `⚡ Crear ${bulkItems.length} Fichas Ahora`}
              </button>
            </div>
          </div>
        </div>
      )}


      {/* MODAL CREAR NUEVA PIEZA */}
        {showNewModal && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(10,25,47,0.7)',
            backdropFilter: 'blur(6px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: '20px'
          }}>
            <div style={{ background: 'white', borderRadius: '20px', padding: '28px 32px', width: '100%', maxWidth: '540px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 50px rgba(0,0,0,0.25)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 900, color: '#0f2a4a' }}>+ Crear Nueva Pieza</h2>
                <button onClick={() => { setShowNewModal(false); setNewPieceFiles([]); }} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#64748b' }}>×</button>
              </div>

              <form onSubmit={handleCreatePiece}>
                <div style={{ marginBottom: '14px' }}>
                  <label style={{ display: 'block', fontSize: '11px', fontWeight: 700, color: 'rgba(15,42,74,0.6)', textTransform: 'uppercase', marginBottom: '6px' }}>Título del Entregable</label>
                  <input value={newForm.title} onChange={e => setNewForm(f => ({ ...f, title: e.target.value }))} placeholder="Ej: Carrusel Lanzamiento / Cuadro de Material Agosto" required style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1.5px solid #cbd5e1', fontSize: '13px', boxSizing: 'border-box' as any }} />
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '14px' }}>
                  <div>
                    <label style={{ display: 'block', fontSize: '11px', fontWeight: 700, color: 'rgba(15,42,74,0.6)', textTransform: 'uppercase', marginBottom: '6px' }}>Marca</label>
                    <select value={newForm.brandId} onChange={e => setNewForm(f => ({ ...f, brandId: e.target.value }))} required style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1.5px solid #cbd5e1', fontSize: '13px', boxSizing: 'border-box' as any }}>
                      <option value="">Seleccionar marca...</option>
                      {brands.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: '11px', fontWeight: 700, color: 'rgba(15,42,74,0.6)', textTransform: 'uppercase', marginBottom: '6px' }}>Formato</label>
                    <select value={newForm.type} onChange={e => setNewForm(f => ({ ...f, type: e.target.value }))} style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1.5px solid #cbd5e1', fontSize: '13px', fontWeight: 700, boxSizing: 'border-box' as any }}>
                      <option value="ESTATICA"> Post Estático</option>
                      <option value="CARRUSEL"> Carrusel (Hasta 10 archivos)</option>
                      <option value="VIDEO"> Video / Reel</option>
                      <option value="CUADRO_MATERIAL"> Cuadro de Material (Drive)</option>
                      <option value="ANIMACION"> Animación</option>
                    </select>
                  </div>
                </div>

                {/* ZONA 1: SELECTOR VISUAL AGRUPADO POR MARCA */}
                {newForm.type === 'CUADRO_MATERIAL' && (
                  <div style={{ marginBottom: '18px', background: '#f0fdf4', padding: '16px', borderRadius: '14px', border: '1.5px solid #86efac' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                      <label style={{ fontSize: '11px', fontWeight: 800, color: '#166534', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <IconFolder size={15} color="#166534" /> 1. Selecciona la Carpeta del Drive a Vincular:
                      </label>
                      <button
                        type="button"
                        onClick={() => setShowInlineNewFolder(!showInlineNewFolder)}
                        style={{ background: 'none', border: 'none', color: '#15803d', fontSize: '11px', fontWeight: 800, cursor: 'pointer', textDecoration: 'underline' }}
                      >
                        {showInlineNewFolder ? '✕ Cancelar' : '+ Crear Nueva Carpeta'}
                      </button>
                    </div>

                    {/* Menú desplegable claro y ordenado con todas las subcarpetas */}
                    <select
                      value={selectedFolderId}
                      onChange={e => setSelectedFolderId(e.target.value)}
                      required={newForm.type === 'CUADRO_MATERIAL'}
                      style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1.5px solid #86efac', fontSize: '13px', fontWeight: 700, background: 'white', color: '#0f2a4a', boxSizing: 'border-box' as any }}
                    >
                      <option value="">-- Haz clic aquí para elegir la carpeta con las imágenes --</option>
                      {brandFoldersList.map(fol => (
                        <option key={fol.id} value={fol.id}>
                          📁 {fol.fullPath || fol.name} ({fol.filesCount || 0} archivos)
                        </option>
                      ))}
                    </select>

                    {/* Tarjeta de Confirmación Visual de la Carpeta Elegida */}
                    {selectedFolderId && (
                      <div style={{ marginTop: '10px', padding: '10px 14px', background: '#ffffff', borderRadius: '10px', border: '1.5px solid #16a34a', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <IconFolder size={18} color="#16a34a" />
                          <div>
                            <div style={{ fontSize: '12px', fontWeight: 800, color: '#15803d' }}>
                              {brandFoldersList.find(f => f.id === selectedFolderId)?.fullPath || 'Carpeta seleccionada'}
                            </div>
                            <div style={{ fontSize: '11px', color: '#64748b' }}>
                              {brandFoldersList.find(f => f.id === selectedFolderId)?.filesCount || 0} recursos listos para revisión secuencial
                            </div>
                          </div>
                        </div>
                        <span style={{ fontSize: '11px', fontWeight: 900, background: '#dcfce7', color: '#15803d', padding: '2px 8px', borderRadius: '6px' }}>
                          VINCULADA ✓
                        </span>
                      </div>
                    )}

                    {/* Creador Rápido de Carpeta */}
                    {showInlineNewFolder && (
                      <div style={{ marginTop: '12px', display: 'flex', gap: '8px' }}>
                        <input
                          type="text"
                          value={inlineNewFolderName}
                          onChange={e => setInlineNewFolderName(e.target.value)}
                          placeholder="Nombre de nueva carpeta (ej: Edwcar / Septiembre)..."
                          style={{ flex: 1, padding: '8px 12px', borderRadius: '8px', border: '1.5px solid #86efac', fontSize: '12px', outline: 'none' }}
                        />
                        <button
                          type="button"
                          onClick={handleCreateInlineFolder}
                          disabled={creatingInlineFolder || !inlineNewFolderName.trim()}
                          style={{ padding: '8px 14px', borderRadius: '8px', border: 'none', background: '#16a34a', color: 'white', fontWeight: 800, fontSize: '12px', cursor: 'pointer' }}
                        >
                          {creatingInlineFolder ? 'Creando...' : 'Crear y Vincular'}
                        </button>
                      </div>
                    )}
                  </div>
                )}

                {/* ZONA 2: SUBIDA MÚLTIPLE DE HASTA 10 IMÁGENES/VIDEOS SIMULTÁNEOS PARA CARRUSEL Y ESTÁTICAS */}
                {newForm.type !== 'CUADRO_MATERIAL' && (
                  <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', fontSize: '11px', fontWeight: 700, color: 'rgba(15,42,74,0.6)', textTransform: 'uppercase', marginBottom: '6px' }}>
                      {newForm.type === 'CARRUSEL' ? 'Subir Contenido (Hasta 10 archivos a la vez)' : 'Subir Contenido'}
                    </label>

                    <div
                      onClick={() => multiFileInputRef.current?.click()}
                      style={{
                        padding: '16px',
                        borderRadius: '12px',
                        border: '2px dashed #cbd5e1',
                        background: '#f8fafc',
                        textAlign: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.2s'
                      }}
                    >
                      <input
                        ref={multiFileInputRef}
                        type="file"
                        multiple={newForm.type === 'CARRUSEL'}
                        accept="image/*,video/*"
                        style={{ display: 'none' }}
                        onChange={handleSelectMultipleFiles}
                      />
                      <div style={{ fontSize: '24px', marginBottom: '4px' }}></div>
                      <div style={{ fontSize: '13px', fontWeight: 700, color: '#0f2a4a' }}>
                        {uploadingMulti ? 'Subiendo archivos...' : 'Subir Contenido (Selecciona hasta 10 imágenes/videos)'}
                      </div>
                      <div style={{ fontSize: '11px', color: '#64748b', marginTop: '2px' }}>
                        {newForm.type === 'CARRUSEL' ? 'Puedes seleccionar hasta 10 archivos juntos con Ctrl + Clic' : 'Formatos: PNG, JPG, MP4, MOV'}
                      </div>
                    </div>

                    {/* Previsualización de los archivos cargados */}
                    {newPieceFiles.length > 0 && (
                      <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', marginTop: '10px', padding: '4px 0' }}>
                        {newPieceFiles.map((url, idx) => (
                          <div key={idx} style={{ position: 'relative', width: '56px', height: '56px', borderRadius: '8px', overflow: 'hidden', border: '1.5px solid #2688c9', flexShrink: 0 }}>
                            <img src={url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            <div style={{ position: 'absolute', top: '2px', left: '2px', background: 'rgba(0,0,0,0.7)', color: 'white', fontSize: '9px', fontWeight: 900, padding: '1px 3px', borderRadius: '3px' }}>
                              #{idx + 1}
                            </div>
                            <button
                              type="button"
                              onClick={() => setNewPieceFiles(prev => prev.filter((_, i) => i !== idx))}
                              style={{ position: 'absolute', top: '2px', right: '2px', background: '#ef4444', color: 'white', border: 'none', borderRadius: '50%', width: '14px', height: '14px', fontSize: '9px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}
                            >
                              ×
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {/* Asignar Múltiples Diseñadores si es Cuadro de Material, o único responsable */}
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'flex', fontSize: '11px', fontWeight: 800, color: 'rgba(15,42,74,0.6)', textTransform: 'uppercase', marginBottom: '8px', alignItems: 'center', gap: '4px' }}>
                    <IconUsers size={14} color="#0070f3" /> {newForm.type === 'CUADRO_MATERIAL' ? 'Asignar Diseñadores al Cuadro de Material (Múltiples)' : 'Asignar Diseñador Responsable'}
                  </label>
                  {newForm.type === 'CUADRO_MATERIAL' ? (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: '8px', maxHeight: '130px', overflowY: 'auto', padding: '8px', background: '#f8fafc', borderRadius: '10px', border: '1.5px solid #cbd5e1' }}>
                      {users.map(u => {
                        const isSelected = assignedTeamIds.includes(u.id);
                        return (
                          <div
                            key={u.id}
                            onClick={() => setAssignedTeamIds(prev => isSelected ? prev.filter(id => id !== u.id) : [...prev, u.id])}
                            style={{
                              padding: '6px 10px',
                              borderRadius: '8px',
                              border: isSelected ? '1.5px solid #0070f3' : '1px solid #cbd5e1',
                              background: isSelected ? '#eff6ff' : '#ffffff',
                              color: isSelected ? '#0070f3' : '#0f2a4a',
                              fontSize: '11px',
                              fontWeight: 700,
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px'
                            }}
                          >
                            <input type="checkbox" checked={isSelected} readOnly style={{ cursor: 'pointer' }} />
                            <span>{u.firstName} {u.lastName?.[0]}.</span>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <select value={newForm.assignedToId} onChange={e => setNewForm(f => ({ ...f, assignedToId: e.target.value }))} style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1.5px solid #cbd5e1', fontSize: '13px', boxSizing: 'border-box' as any }}>
                      <option value="">Sin asignar (Opcional)</option>
                      {users.map(u => <option key={u.id} value={u.id}>{u.firstName} {u.lastName} ({u.role})</option>)}
                    </select>
                  )}
                </div>

                {/* COPY (NO SE MUESTRA EN CUADRO DE MATERIAL) */}
                {newForm.type !== 'CUADRO_MATERIAL' && (
                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', fontSize: '11px', fontWeight: 700, color: 'rgba(15,42,74,0.6)', textTransform: 'uppercase', marginBottom: '6px' }}>Copy Inicial (Opcional)</label>
                    <textarea value={newForm.copy} onChange={e => setNewForm(f => ({ ...f, copy: e.target.value }))} placeholder="Texto o instrucciones de la pieza..." rows={3} style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1.5px solid #cbd5e1', fontSize: '13px', resize: 'vertical' as any, boxSizing: 'border-box' as any }} />
                  </div>
                )}

                <div style={{ display: 'flex', gap: '10px' }}>
                  <button type="button" onClick={() => { setShowNewModal(false); setNewPieceFiles([]); }} style={{ flex: 1, padding: '11px', borderRadius: '10px', border: '1px solid #cbd5e1', background: 'white', fontWeight: 700, fontSize: '13px', cursor: 'pointer' }}>Cancelar</button>
                  <button type="submit" disabled={creatingPiece || uploadingMulti} style={{ flex: 1, padding: '11px', borderRadius: '10px', border: 'none', background: 'linear-gradient(135deg,#1e6fa8,#2688c9)', color: 'white', fontWeight: 700, fontSize: '13px', cursor: 'pointer' }}>{creatingPiece ? 'Creando...' : 'Crear Pieza'}</button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* BARRA FLOTANTE DE ACCIONES MASIVAS */}
        {selectedPieceIds.length > 0 && (
          <div style={{
            position: 'fixed',
            bottom: '26px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 999,
            background: 'rgba(15, 42, 74, 0.94)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            border: '1.5px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '24px',
            padding: '10px 18px',
            display: 'flex',
            alignItems: 'center',
            gap: '14px',
            boxShadow: '0 16px 36px -4px rgba(15, 42, 74, 0.45), 0 0 0 1px rgba(255, 255, 255, 0.1)',
            animation: 'glassDeploy 0.25s cubic-bezier(0.16, 1, 0.3, 1) forwards'
          }}>
            {/* Badge contador */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              color: '#ffffff',
              fontSize: '13px',
              fontWeight: 700
            }}>
              <span style={{
                background: '#0070f3',
                color: '#ffffff',
                width: '26px',
                height: '26px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: 900
              }}>
                {selectedPieceIds.length}
              </span>
              <span>{selectedPieceIds.length === 1 ? '1 ficha seleccionada' : `${selectedPieceIds.length} fichas seleccionadas`}</span>
            </div>

            {/* Divisor */}
            <div style={{ width: '1px', height: '24px', background: 'rgba(255, 255, 255, 0.2)' }} />

            {/* Seleccionar todo / Deseleccionar */}
            <button
              type="button"
              onClick={handleSelectAll}
              style={{
                background: 'rgba(255, 255, 255, 0.12)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '12px',
                padding: '7px 14px',
                color: '#ffffff',
                fontSize: '12px',
                fontWeight: 700,
                cursor: 'pointer',
                fontFamily: '"Montserrat", sans-serif',
                transition: 'all 0.2s ease',
                whiteSpace: 'nowrap'
              }}
              onMouseEnter={e => (e.currentTarget.style.background = 'rgba(255, 255, 255, 0.22)')}
              onMouseLeave={e => (e.currentTarget.style.background = 'rgba(255, 255, 255, 0.12)')}
            >
              {filteredPieces.length > 0 && filteredPieces.every(p => selectedPieceIds.includes(p.id))
                ? 'Deseleccionar todas'
                : `Seleccionar todas (${filteredPieces.length})`}
            </button>

            {/* Botón Eliminar Masivamente */}
            {canManage && (
              <button
                type="button"
                onClick={() => setShowBulkDeleteModal(true)}
                style={{
                  background: 'linear-gradient(135deg, #ef4444, #dc2626)',
                  border: 'none',
                  borderRadius: '12px',
                  padding: '8px 18px',
                  color: '#ffffff',
                  fontSize: '12px',
                  fontWeight: 800,
                  cursor: 'pointer',
                  fontFamily: '"Montserrat", sans-serif',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '7px',
                  boxShadow: '0 4px 14px rgba(239, 68, 68, 0.45)',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap'
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 6px 18px rgba(239, 68, 68, 0.55)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 14px rgba(239, 68, 68, 0.45)';
                }}
              >
                <IconTrash size={15} color="#ffffff" />
                <span>Eliminar seleccionadas ({selectedPieceIds.length})</span>
              </button>
            )}

            {/* Botón Cancelar Selección */}
            <button
              type="button"
              onClick={handleClearSelection}
              title="Cancelar selección"
              style={{
                background: 'transparent',
                border: 'none',
                color: 'rgba(255, 255, 255, 0.65)',
                cursor: 'pointer',
                padding: '6px',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '16px',
                lineHeight: 1
              }}
              onMouseEnter={e => (e.currentTarget.style.color = '#ffffff')}
              onMouseLeave={e => (e.currentTarget.style.color = 'rgba(255, 255, 255, 0.65)')}
            >
              ✕
            </button>
          </div>
        )}

        {/* MODAL DE CONFIRMACIÓN DE ELIMINACIÓN MASIVA */}
        {showBulkDeleteModal && (
          <div
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(15, 42, 74, 0.45)',
              backdropFilter: 'blur(8px)',
              WebkitBackdropFilter: 'blur(8px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10000,
              padding: '20px'
            }}
            onClick={() => !isBulkDeleting && setShowBulkDeleteModal(false)}
          >
            <div
              style={{
                background: 'white',
                borderRadius: '24px',
                padding: '32px',
                width: '100%',
                maxWidth: '440px',
                boxShadow: '0 25px 50px -12px rgba(15, 42, 74, 0.25)',
                textAlign: 'center',
                fontFamily: '"Montserrat", sans-serif'
              }}
              onClick={e => e.stopPropagation()}
            >
              <div style={{
                width: '60px',
                height: '60px',
                borderRadius: '20px',
                background: '#fef2f2',
                color: '#ef4444',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 18px'
              }}>
                <IconTrash size={28} color="#ef4444" />
              </div>

              <h3 style={{ margin: '0 0 10px', fontSize: '18px', fontWeight: 900, color: '#0f2a4a' }}>
                ¿Eliminar {selectedPieceIds.length} {selectedPieceIds.length === 1 ? 'ficha' : 'fichas'} de contenido?
              </h3>

              <p style={{ margin: '0 0 24px', fontSize: '13px', color: '#64748b', lineHeight: 1.6 }}>
                Esta acción es <strong>permanente e irreversible</strong>. Se eliminarán los artes, archivos adjuntos, comentarios y aprobaciones vinculadas a las fichas seleccionadas.
              </p>

              <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                <button
                  type="button"
                  disabled={isBulkDeleting}
                  onClick={() => setShowBulkDeleteModal(false)}
                  style={{
                    flex: 1,
                    padding: '11px 20px',
                    borderRadius: '12px',
                    border: '1.5px solid #cbd5e1',
                    background: 'white',
                    color: '#475569',
                    fontSize: '13px',
                    fontWeight: 700,
                    cursor: isBulkDeleting ? 'not-allowed' : 'pointer',
                    fontFamily: '"Montserrat", sans-serif'
                  }}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  disabled={isBulkDeleting}
                  onClick={handleBulkDelete}
                  style={{
                    flex: 1,
                    padding: '11px 20px',
                    borderRadius: '12px',
                    border: 'none',
                    background: 'linear-gradient(135deg, #ef4444, #dc2626)',
                    color: 'white',
                    fontSize: '13px',
                    fontWeight: 800,
                    cursor: isBulkDeleting ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    boxShadow: '0 4px 14px rgba(239, 68, 68, 0.4)',
                    fontFamily: '"Montserrat", sans-serif',
                    opacity: isBulkDeleting ? 0.7 : 1
                  }}
                >
                  {isBulkDeleting ? (
                    <span>Eliminando...</span>
                  ) : (
                    <>
                      <IconTrash size={16} color="#ffffff" />
                      <span>Sí, eliminar</span>
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}

      </main>
    </div>
  );
};

export default Content;
